(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7883],{

/***/ 3010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddressSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/reactgooglemapsapi.esm.js + 3 modules
var reactgooglemapsapi_esm = __webpack_require__(83854);
// EXTERNAL MODULE: ./node_modules/use-places-autocomplete/dist/index.esm.js
var index_esm = __webpack_require__(20906);
// EXTERNAL MODULE: ./styles/modules/AddressSearch.module.scss
var AddressSearch_module = __webpack_require__(25192);
var AddressSearch_module_default = /*#__PURE__*/__webpack_require__.n(AddressSearch_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/address.js
var parseAddress = function(address) {
    var parsedAddress = {};
    address.address_components.map(function(item) {
        if (item.types[0]) {
            var type = item.types[0];
            if (type === "postal_code") {
                type = "postalCode";
            } else if (type === "postal_town") {
                type = "city";
            }
            parsedAddress[type] = item.long_name;
        }
    });
    var streetNumber = parsedAddress.subpremise || parsedAddress.street_number || "";
    var streetName = parsedAddress.premise || parsedAddress.route || "";
    var street = "";
    if (streetNumber !== "") {
        street += "".concat(streetNumber, " ");
    }
    street += streetName;
    parsedAddress.street = street;
    return parsedAddress;
};


// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
;// CONCATENATED MODULE: ./components/AddressSearch.js









var googleMapsConfig = {
    googleMapsApiKey: "AIzaSyDP0GVp9O95-FSauY7rXorc_40HG9fjzms",
    language: "en-GB",
    libraries: [
        "places"
    ]
};
function AddressSearch(param) {
    var onUpdate = param.onUpdate, placeholder = param.placeholder, label = param.label, labelAbove = param.labelAbove, register = param.register, name = param.name;
    var ref = (0,reactgooglemapsapi_esm/* useLoadScript */.Db)(googleMapsConfig), isLoaded = ref.isLoaded, loadError = ref.loadError;
    var showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
        onUpdate: onUpdate,
        placeholder: placeholder,
        label: label,
        labelAbove: labelAbove,
        register: register,
        name: name
    });
    if (loadError) showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Error"
    });
    if (!isLoaded) showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddressSearch_module_default()).wrapper,
        children: showElem
    });
}
function Search(param) {
    var onUpdate = param.onUpdate, placeholder = param.placeholder, label = param.label, labelAbove = param.labelAbove, register = param.register, name = param.name;
    var ref = (0,index_esm/* default */.ZP)(), value = ref.value, _suggestions = ref.suggestions, status = _suggestions.status, data = _suggestions.data, setValue = ref.setValue, clearSuggestions = ref.clearSuggestions;
    var ref1 = (0,react.useState)(false), showResults = ref1[0], setShowResults = ref1[1];
    var handleInput = function(e) {
        var val = e.target.value;
        setValue(val);
    };
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var results, parsedAddress, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValue(item.description, false);
                        clearSuggestions();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,index_esm/* getGeocode */.LM)({
                                address: item.description
                            })
                        ];
                    case 2:
                        results = _state.sent();
                        if (results.length > 0) {
                            parsedAddress = parseAddress(results[0]);
                            parsedAddress.fullAddress = item.description;
                            onUpdate(parsedAddress);
                            setValue("");
                            clearSuggestions();
                            setShowResults(false);
                        } else {
                            alert("error");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error); // eslint-disable-line
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelect(item) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    (AddressSearch_module_default()).inputWrapper,
                    labelAbove ? (AddressSearch_module_default()).hasLabelAbove : "", 
                ].join(" "),
                children: [
                    labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (AddressSearch_module_default()).labelAbove,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        name: name,
                        onChange: handleInput,
                        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : en/* profile.header.address.sidebar.search */.N5.Fs.Lk.r.yC,
                        className: [
                            (AddressSearch_module_default()).input,
                            labelAbove ? (AddressSearch_module_default()).hasLabelAbove : "", 
                        ].join(" "),
                        value: value,
                        onFocus: function() {
                            setShowResults(true);
                        },
                        ref: register
                    }),
                    !labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: label
                    })
                ]
            }),
            status === "OK" && showResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "border-gray",
                    (AddressSearch_module_default()).results
                ].join(" "),
                children: data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return handleSelect(item);
                        },
                        className: (AddressSearch_module_default()).resultsItem,
                        children: item.description
                    }, item.place_id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 74459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_CrosshatchLine_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53074);
/* harmony import */ var styles_modules_CrosshatchLine_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_CrosshatchLine_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var CrosshatchLine = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        className: [
            (styles_modules_CrosshatchLine_module_scss__WEBPACK_IMPORTED_MODULE_3___default().line),
            props.className
        ].join(" ")
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CrosshatchLine);


/***/ }),

/***/ 21105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/Input.module.scss
var Input_module = __webpack_require__(47909);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/Svg/Eye.js

function Eye(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1418 916",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M708.531 676.277c120.483 0 218.154-97.671 218.154-218.154 0-120.483-97.671-218.154-218.154-218.154-120.483 0-218.154 97.671-218.154 218.154 0 120.483 97.671 218.154 218.154 218.154z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M1395.29 397.695C1227.6 195.057 973.767 0 708.516 0 443.214 0 189.318 195.193 21.7404 397.695c-28.9872 35.013-28.9872 85.843 0 120.857 42.131 50.911 130.4556 149.19 248.4226 235.061 297.096 216.277 578.956 216.755 876.707 0 117.97-85.871 206.29-184.15 248.42-235.061 28.9-34.946 29.05-85.729 0-120.857zM708.516 152.708c168.415 0 305.414 137 305.414 305.415 0 168.415-136.999 305.416-305.414 305.416S403.101 626.538 403.101 458.123s137-305.415 305.415-305.415z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Input.js





var Input = function(param) {
    var value = param.value, type = param.type, onFocus = param.onFocus, onBlur = param.onBlur, onChange = param.onChange, onKeyUp = param.onKeyUp, placeholder = param.placeholder, label = param.label, name = param.name, disabled = param.disabled, color = param.color, error = param.error, register = param.register, _classes = param.classes, classes = _classes === void 0 ? [] : _classes, labelAbove = param.labelAbove, autoComplete = param.autoComplete;
    var ref = (0,react.useState)(type || "text"), inputType = ref[0], setInputType = ref[1];
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        var inputValue = (ref = document.getElementById(name)) === null || ref === void 0 ? void 0 : ref.value;
        if (value && value.trim() !== "" || inputValue && inputValue.trim() !== "") setActive(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Input_module_default()).inputWrapper,
            (Input_module_default())["inputWrapper".concat(color)],
            error ? (Input_module_default()).inputWrapperError : null,
            labelAbove ? (Input_module_default()).hasLabelAbove : "", 
        ].join(" "),
        children: [
            labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Input_module_default()).labelAbove,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: inputType,
                className: [
                    (Input_module_default()).input,
                    active ? (Input_module_default()).inputActive : null, 
                ].concat((0,_to_consumable_array/* default */.Z)(classes), [
                    error ? (Input_module_default()).error : "",
                    labelAbove ? (Input_module_default()).hasLabelAbove : "", 
                ]).join(" "),
                onFocus: function(event) {
                    setActive(true);
                    onFocus ? onFocus(event) : null;
                },
                onBlur: function(event) {
                    event.target.value ? null : setActive(false);
                    onBlur ? onBlur(event) : null;
                },
                onChange: function(event) {
                    setActive(true);
                    onChange ? onChange(event) : null;
                },
                onKeyUp: onKeyUp ? function(param) {
                    var value = param.target.value;
                    return onKeyUp(name, value.trim());
                } : null,
                ref: register,
                placeholder: placeholder,
                defaultValue: value,
                disabled: disabled,
                autoComplete: autoComplete
            }),
            !labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                children: label
            }),
            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Input_module_default()).password,
                onClick: function() {
                    return inputType === "password" ? setInputType("text") : setInputType("password");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {})
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Input_module_default()).error,
                children: error.message
            })
        ]
    });
};
/* harmony default export */ var components_Input = (Input);


/***/ }),

/***/ 35270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42719);
/* harmony import */ var styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Svg_ArrowDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87878);







var OptionSelect = function(param) {
    var options = param.options, register = param.register, value = param.value.value, setValue = param.setValue, defaultValue = param.defaultValue;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showList = ref[0], setShowList = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().dropdown),
            (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inline)
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input),
                    (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputSelect)
                ].join(" "),
                onClick: function() {
                    return setShowList(!showList);
                },
                children: [
                    value,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg_ArrowDown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            }),
            showList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().listWrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list),
                    children: [
                        defaultValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().listItem),
                            onClick: function() {
                                setValue({
                                    id: undefined,
                                    value: defaultValue
                                });
                                setShowList(false);
                            },
                            children: defaultValue
                        }),
                        options.map(function(_param) {
                            var id = _param.id, name = _param.name, position = _param.position, imageUrl = _param.imageUrl, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                "id",
                                "name",
                                "position",
                                "imageUrl"
                            ]);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().listItem),
                                onClick: function() {
                                    setValue((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        id: id,
                                        value: name
                                    }, imageUrl && {
                                        image: imageUrl
                                    }), {
                                        name: name,
                                        position: position
                                    }), rest));
                                    setShowList(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
                                    children: [
                                        imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (styles_modules_Dropdown_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: imageUrl,
                                                alt: name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: position
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, "option-select-".concat(id));
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OptionSelect);


/***/ }),

/***/ 6266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Sidescreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/modules/Sidescreen.module.scss
var Sidescreen_module = __webpack_require__(17010);
var Sidescreen_module_default = /*#__PURE__*/__webpack_require__.n(Sidescreen_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./store/company/index.js
var store_company = __webpack_require__(3383);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./store/ux.js
var ux = __webpack_require__(30807);
// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var components_Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./styles/modules/Divider.module.scss
var Divider_module = __webpack_require__(57223);
var Divider_module_default = /*#__PURE__*/__webpack_require__.n(Divider_module);
;// CONCATENATED MODULE: ./components/Divider.js



var Divider_Divider = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread/* default */.Z)({
        className: (Divider_module_default()).divider
    }, props));
};
/* harmony default export */ var components_Divider = (Divider_Divider);

// EXTERNAL MODULE: ./components/Typo.js
var components_Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./components/Sidescreen/LimitedTextArea.js
var LimitedTextArea = __webpack_require__(97919);
// EXTERNAL MODULE: ./data/globalConstants.js
var globalConstants = __webpack_require__(23208);
// EXTERNAL MODULE: ./styles/modules/SidescreenEditCompanyInfo.module.scss
var SidescreenEditCompanyInfo_module = __webpack_require__(29455);
var SidescreenEditCompanyInfo_module_default = /*#__PURE__*/__webpack_require__.n(SidescreenEditCompanyInfo_module);
// EXTERNAL MODULE: ./components/Input.js + 1 modules
var components_Input = __webpack_require__(21105);
// EXTERNAL MODULE: ./components/Profile/AddContent.js
var Profile_AddContent = __webpack_require__(93045);
// EXTERNAL MODULE: ./components/Profile/EditContent.js
var Profile_EditContent = __webpack_require__(90257);
// EXTERNAL MODULE: ./styles/modules/popUps/Uploader.module.scss
var Uploader_module = __webpack_require__(23093);
var Uploader_module_default = /*#__PURE__*/__webpack_require__.n(Uploader_module);
;// CONCATENATED MODULE: ./components/Uploader/UploaderDragAndDrop.js



function UploaderDragAndDrop(props) {
    var dropRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), dragging = ref[0], setDragging = ref[1];
    var dragCounter = 0;
    var style = props.style, className = props.className;
    var handleDrag = function(e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleDragIn = function(e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragging(true);
        }
    };
    var handleDragOut = function(e) {
        e.preventDefault();
        e.stopPropagation();
        dragCounter--;
        if (dragCounter < 1 && dragging) {
            setDragging(false);
        }
    };
    var handleDrop = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            props.handleDrop(e.dataTransfer.files);
            e.dataTransfer.clearData();
            dragCounter = 0;
        }
    };
    (0,react.useEffect)(function() {
        var div = dropRef.current;
        div.addEventListener("dragenter", handleDragIn);
        div.addEventListener("dragleave", handleDragOut);
        div.addEventListener("dragover", handleDrag);
        div.addEventListener("drop", handleDrop);
    // return () => {
    //     const div = dropRef.current;
    // div.removeEventListener('dragenter', handleDragIn);
    // div.removeEventListener('dragleave', handleDragOut);
    // div.removeEventListener('dragover', handleDrag);
    // div.removeEventListener('drop', handleDrop);
    // };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: dropRef,
        style: style,
        className: [
            className,
            dragging ? (Uploader_module_default()).dropActive : ""
        ].join(" "),
        children: [
            dragging && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Uploader_module_default()).dropBorder
            }),
            props.children
        ]
    });
}

;// CONCATENATED MODULE: ./components/Uploader/UploaderSelect.js




function UploaderSelect(param) {
    var onChange = param.onChange;
    var ref = (0,react.useState)(null), file = ref[0], setFile = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var handleChange = function(e) {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
            onChange(e.target.files[0]);
        }
    };
    var handleDrop = function(files) {
        if (files.length > 0) {
            setFile(files[0]);
            onChange(files[0]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploaderDragAndDrop, {
            handleDrop: handleDrop,
            className: (Uploader_module_default()).dropArea,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Uploader_module_default()).dropAreaBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        onChange: handleChange,
                        className: (Uploader_module_default()).dropInput
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (Uploader_module_default()).title,
                            (Uploader_module_default()).dropAreaTitle
                        ].join(" "),
                        children: "Drag your file here"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Uploader_module_default()).dropAreaPlus,
                        children: "Add file"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Uploader_module_default()).dropAreaSubtitle,
                        children: "or select a file"
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./components/CrosshatchLine.js
var CrosshatchLine = __webpack_require__(74459);
// EXTERNAL MODULE: ./helpers/file.js + 1 modules
var helpers_file = __webpack_require__(30701);
;// CONCATENATED MODULE: ./components/Svg/File.js

function File_File(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 21",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: fill,
            fillRule: "evenodd",
            d: "M12 0H.75v21H18V6l-6-6zm-1.5 7.5h5.25L10.5 2.25V7.5z",
            clipRule: "evenodd"
        })
    });
}

;// CONCATENATED MODULE: ./components/Uploader/UploaderSettings.js







// import File from 'components/svg/File';

function UploaderSettings(param) {
    var file = param.file, fileSrc = param.fileSrc, onSubmit = param.onSubmit;
    var ref = (0,react.useState)((0,helpers_file/* getFileTitle */.Xc)(file.name)), title = ref[0], setTitle = ref[1];
    var handleSubmit = function(e) {
        e.preventDefault();
        if (onSubmit) {
            onSubmit({
                title: title
            });
        }
    };
    var preview;
    if (file.type.match("image.*")) {
        preview = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: [
                "col",
                (Uploader_module_default()).settingsPreview
            ].join(" "),
            style: {
                backgroundImage: "url(".concat(fileSrc, ")")
            }
        });
    } else {
        preview = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: [
                "col",
                (Uploader_module_default()).settingsPreview
            ].join(" "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(File_File, {
                fill: "#aaa"
            })
        });
    }
    (0,react.useEffect)(function() {
        var handleKeyUp = function(e) {
            var ref;
            var pressed = (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (pressed === "enter") {
                handleSubmit(e);
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        return function() {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Uploader_module_default()).settingsRow,
                children: [
                    preview,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            "col",
                            (Uploader_module_default()).settingsBody
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Input/* default */.Z, {
                            value: title,
                            color: "dark",
                            label: "Title",
                            onChange: function(param) {
                                var value = param.target.value;
                                return setTitle(value.trim());
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Uploader_module_default()).cta,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                        title: "Confirm",
                        onClick: handleSubmit,
                        disabled: title === ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Uploader_module_default()).crosshatch,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrosshatchLine/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Uploader/UploaderProgress.js







function UploaderProgress(param) {
    var file = param.file, settings = param.settings, onSuccess = param.onSuccess, onError = param.onError;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(0), prc = ref[0], setPrc = ref[1];
    (0,react.useEffect)(function() {
        function uploadFile() {
            return _uploadFile.apply(this, arguments);
        }
        function _uploadFile() {
            _uploadFile = (0,src_async_to_generator/* default */.Z)(function() {
                var formData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            formData = new FormData();
                            formData.append(settings.title, file);
                            return [
                                4,
                                dispatch((0,store_company/* addFile */.N2)(formData, function(val) {
                                    setPrc(val);
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _uploadFile.apply(this, arguments);
        }
        uploadFile().then(function(res) {
            onSuccess();
        });
    }, [
        file
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Uploader_module_default()).progressBar,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Uploader_module_default()).progressBarFill,
                style: {
                    width: "".concat(prc, "%")
                }
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-easy-crop/index.module.js + 1 modules
var index_module = __webpack_require__(83913);
;// CONCATENATED MODULE: ./helpers/canvas.js


var createImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.addEventListener("load", function() {
            return resolve(image);
        });
        image.addEventListener("error", function(error) {
            return reject(error);
        });
        image.setAttribute("crossOrigin", "anonymous"); // todo: remove?
        image.src = url;
    });
};
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param fileName
 */ function getCroppedImg(imageSrc, pixelCrop, fileName) {
    return _getCroppedImg.apply(this, arguments);
}
function _getCroppedImg() {
    _getCroppedImg = (0,src_async_to_generator/* default */.Z)(function(imageSrc, pixelCrop, fileName) {
        var image, canvas, ctx, maxSize, safeArea, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        createImage(imageSrc)
                    ];
                case 1:
                    image = _state.sent();
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    maxSize = Math.max(image.width, image.height);
                    safeArea = 2 * (maxSize / 2 * Math.sqrt(2));
                    // set each dimensions to double largest dimension to allow for a safe area for the
                    // image to rotate in without being clipped by canvas context
                    canvas.width = safeArea;
                    canvas.height = safeArea;
                    // translate canvas context to a central location on image to allow rotating around the center.
                    ctx.translate(safeArea / 2, safeArea / 2);
                    ctx.translate(-safeArea / 2, -safeArea / 2);
                    // draw rotated image and store data.
                    ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
                    data = ctx.getImageData(0, 0, safeArea, safeArea);
                    // set canvas width to final desired crop size - this will clear existing context
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // paste generated rotate image with correct offsets for x,y crop values.
                    ctx.putImageData(data, Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x), Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y));
                    return [
                        2,
                        new Promise(function(resolve) {
                            var b64 = canvas.toDataURL(null, 0.8);
                            resolve({
                                src: b64,
                                file: dataURLtoFile(b64, fileName)
                            });
                        })
                    ];
            }
        });
    });
    return _getCroppedImg.apply(this, arguments);
}
var dataURLtoFile = function(dataurl) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "file", forceJPG = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var arr = dataurl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    var ext = mime.split("/");
    ext = ext[ext.length - 1];
    var fileName = name;
    if (fileName.includes(".")) {
        fileName = name.split(".");
        fileName.pop();
        fileName = fileName.join(".");
    }
    var fileExt = "jpg";
    if (forceJPG) {
        mime = "image/jpeg";
    } else {
        if (ext === "png") fileExt = "png";
    }
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([
        u8arr
    ], "".concat(fileName, ".").concat(fileExt), {
        type: mime
    });
};
function cropImage(url) {
    return new Promise(function(resolve) {
        var inputImage = new Image();
        inputImage.src = url;
        inputImage.onload = function() {
            // let's store the width and height of our image
            var inputWidth = inputImage.naturalWidth;
            var inputHeight = inputImage.naturalHeight;
            var outputWidth;
            var outputHeight;
            var greaterSize = inputWidth >= inputHeight ? inputWidth : inputHeight;
            outputWidth = greaterSize;
            outputHeight = greaterSize;
            // calculate the position to draw the image at
            var outputX = (outputWidth - inputWidth) * 0.5;
            var outputY = (outputHeight - inputHeight) * 0.5;
            // create a canvas that will present the output image
            var outputImage = document.createElement("canvas");
            // set it to the same size as the image
            outputImage.width = outputWidth;
            outputImage.height = outputHeight;
            // draw our image at position 0, 0 on the canvas
            var ctx = outputImage.getContext("2d");
            ctx.drawImage(inputImage, outputX, outputY);
            // change non-opaque pixels to white
            var imgData = ctx.getImageData(0, 0, outputImage.width, outputImage.height);
            var data = imgData.data;
            for(var i = 0; i < data.length; i += 4){
                if (data[i + 3] < 255) {
                    data[i] = 255 - data[i];
                    data[i + 1] = 255 - data[i + 1];
                    data[i + 2] = 255 - data[i + 2];
                    data[i + 3] = 255 - data[i + 3];
                }
            }
            ctx.putImageData(imgData, 0, 0);
            var output = outputImage;
            // Resize image to 500x500;
            if (greaterSize > 500) {
                var outputImageResized = document.createElement("canvas");
                var resizedContext = outputImageResized.getContext("2d");
                outputImageResized.height = 500;
                outputImageResized.width = 500;
                resizedContext.drawImage(outputImage, 0, 0, 500, 500);
                output = outputImageResized;
            }
            var b64 = output.toDataURL("image/jpeg", 0.8);
            resolve({
                src: b64,
                file: dataURLtoFile(b64, "logo", true)
            });
        };
    });
}

;// CONCATENATED MODULE: ./components/Uploader/UploaderCropper.js









function UploaderCropper(param) {
    var fileSrc = param.fileSrc, file = param.file, onSubmit = param.onSubmit;
    var ref = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref[0], setCrop = ref[1];
    var ref1 = (0,react.useState)(1), zoom = ref1[0], setZoom = ref1[1];
    var ref2 = (0,react.useState)(null), croppedAreaPixels = ref2[0], setCroppedAreaPixels = ref2[1];
    var onCropComplete = (0,react.useCallback)(function(croppedArea, croppedAreaPixels) {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    var getCroppedImage = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var cropped, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getCroppedImg(fileSrc, croppedAreaPixels, file.name)
                        ];
                    case 2:
                        cropped = _state.sent();
                        onSubmit(cropped);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.error(e1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fileSrc,
        croppedAreaPixels
    ]);
    var handleRangeChange = function(e) {
        var newZoom = parseFloat(e.target.value);
        setZoom(newZoom);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Uploader_module_default()).cropContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.Z, {
                    image: fileSrc,
                    crop: crop,
                    zoom: zoom,
                    aspect: 1,
                    onCropChange: setCrop,
                    onCropComplete: onCropComplete,
                    onZoomChange: setZoom
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Uploader_module_default()).cropControls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "range",
                        min: 1,
                        max: 3,
                        value: zoom,
                        step: 0.1,
                        onChange: handleRangeChange,
                        className: (Uploader_module_default()).cropRange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Uploader_module_default()).cta,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                                title: "Confirm",
                                onClick: getCroppedImage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Uploader_module_default()).crosshatch,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrosshatchLine/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Uploader.js











var MAX_FILE_SIZE = 50 * 1024 * 1024;
function Uploader_Uploader(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _croppable = param.croppable, croppable = _croppable === void 0 ? false : _croppable, onSubmit = param.onSubmit, onCancel = param.onCancel, _returnFile = param.returnFile, returnFile = _returnFile === void 0 ? false : _returnFile, _noSettings = param.noSettings, noSettings = _noSettings === void 0 ? true : _noSettings, _allowedTypes = param.allowedTypes, allowedTypes = _allowedTypes === void 0 ? "images" : _allowedTypes, _forceCrop = param.forceCrop, forceCrop = _forceCrop === void 0 ? false : _forceCrop;
    var ref = (0,react.useState)(null), file = ref[0], setFile = ref[1];
    var ref1 = (0,react.useState)(null), fileSrc = ref1[0], setFileSrc = ref1[1];
    var ref2 = (0,react.useState)({
        title: noSettings ? Math.random().toString(36).substring(3) : null
    }), fileSettings = ref2[0], setFileSettings = ref2[1];
    var ref3 = (0,react.useState)(false), uploaded = ref3[0], setUploaded = ref3[1];
    var ref4 = (0,react.useState)(false), uploadError = ref4[0], setUploadError = ref4[1];
    var ref5 = (0,react.useState)("select"), currentStep = ref5[0], setCurrentStep = ref5[1];
    var ref6 = (0,react.useState)(!croppable), cropped = ref6[0], setCropped = ref6[1];
    var allowedFileTypes = (0,helpers_file/* getAllowedTypes */.oe)(allowedTypes);
    var ref7 = (0,react.useState)(null), error = ref7[0], setError = ref7[1];
    var ref8 = (0,react.useState)(null), forceCropped = ref8[0], setForceCropped = ref8[1];
    var handleChangeSelect = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(selectedFile) {
            var fileExt, allowed, tooBig, imageDataUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedFile) return [
                            2,
                            null
                        ];
                        fileExt = (0,helpers_file/* getFileType */.JB)(selectedFile.type);
                        allowed = allowedFileTypes.includes(fileExt);
                        tooBig = selectedFile.size > MAX_FILE_SIZE;
                        if (!!allowed) return [
                            3,
                            1
                        ];
                        setError("This file type is not allowed.");
                        return [
                            3,
                            5
                        ];
                    case 1:
                        if (!tooBig) return [
                            3,
                            2
                        ];
                        setError("Selected file is too big. Maximum upload size is 50MB.");
                        return [
                            3,
                            5
                        ];
                    case 2:
                        if (!selectedFile.type.match("image.*")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,helpers_file/* readFile */.pJ)(selectedFile)
                        ];
                    case 3:
                        imageDataUrl = _state.sent();
                        setFileSrc(imageDataUrl);
                        _state.label = 4;
                    case 4:
                        setFile(selectedFile);
                        setError(null);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeSelect(selectedFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleForceCrop = function(img) {
        setFile(img.file);
        setFileSrc(img.src);
        setForceCropped(true);
    };
    var handleChangeCropper = function(img) {
        setFile(img.file);
        setFileSrc(img.src);
        setCropped(true);
    };
    var handleConfirmSettings = function(settings) {
        setFileSettings(settings);
    };
    var handleProgressSuccess = function() {
        setUploaded(true);
    };
    var handleProgressError = function() {
        setUploadError(true);
    };
    var handleConfirmSuccess = function() {
        if (returnFile) {
            onSubmit({
                file: file,
                src: fileSrc
            });
        } else {
            onSubmit();
        }
        // setError(null);
        resetPopup();
    };
    var handleCancel = function() {
        resetPopup();
        onCancel();
    };
    var handleOverlayClick = function(e) {
        e.stopPropagation();
        handleCancel();
    };
    var resetPopup = function() {
        setError(null);
        setFile(null);
        setFileSrc(null);
        setError(false);
        setForceCropped(false);
        setFileSettings({
            title: noSettings ? Math.random().toString(36).substring(3) : null
        });
        setUploaded(false);
        setUploadError(false);
        setCurrentStep("select");
        setCropped(!croppable);
    };
    var steps = {
        select: {
            title: "Select a file",
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploaderSelect, {
                onChange: handleChangeSelect
            })
        },
        crop: {
            title: "Crop your image",
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploaderCropper, {
                fileSrc: fileSrc,
                file: file,
                onSubmit: handleChangeCropper
            })
        },
        settings: {
            title: "File settings",
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploaderSettings, {
                fileSrc: fileSrc,
                file: file,
                onSubmit: handleConfirmSettings
            })
        },
        uploading: {
            title: "Uploading file",
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploaderProgress, {
                file: file,
                onSuccess: handleProgressSuccess,
                onError: handleProgressError,
                settings: fileSettings
            })
        },
        uploading_error: {
            title: "Uploading error",
            component: null
        }
    };
    (0,react.useEffect)(function() {
        if (!file) {
            setCurrentStep("select");
        } else if (forceCrop && !forceCropped) {
            cropImage(fileSrc, 1).then(function(croppedFile) {
                handleForceCrop(croppedFile);
            });
        // setForceCropped(fileSrc);
        } else if (file && !cropped && !forceCrop) {
            setCurrentStep("crop");
        } else if ((cropped || forceCropped) && !noSettings && !fileSettings.title) {
            setCurrentStep("settings");
        } else if (!uploaded && !uploadError && !returnFile) {
            setCurrentStep("uploading");
        } else if (!uploaded && !returnFile && uploadError) {
            console.error("step: ", "uploadError");
            setCurrentStep("uploading_error");
        } else {
            handleConfirmSuccess();
        }
    }, [
        file,
        fileSettings,
        uploaded,
        uploadError,
        cropped
    ]);
    (0,react.useEffect)(function() {
        var handleKeyUp = function(e) {
            var ref;
            var pressed = (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (pressed === "escape") {
                handleCancel();
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        return function() {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (Uploader_module_default()).overlay,
            isActive ? (Uploader_module_default()).isActive : null
        ].join(" "),
        onClick: handleOverlayClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Uploader_module_default()).wrapper,
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Uploader_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Uploader_module_default()).title,
                            children: steps[currentStep].title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (Uploader_module_default()).close,
                            onClick: handleCancel,
                            type: "button",
                            children: "Close"
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Uploader_module_default()).error,
                    children: error
                }),
                steps[currentStep].component
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Sidescreen/Details.js













// Chrome ignores autocomplete="off" and fills the editor's saved contact; an unknown token stops it.
var noAutofill = "no-autofill";
var Details_Details = function(param) {
    var callback = param.callback, register = param.register, errors = param.errors, data = param.data, logoPreview = param.logoPreview, handleFile = param.handleFile, isJournalist = param.isJournalist;
    var ref = (0,react.useState)(data), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(false), uploadPopupActive = ref1[0], setUploadPopupActive = ref1[1];
    var handleKeyUp = function(name, val) {
        var newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);
        callback(newFormData);
    };
    var handlePopupCancel = function() {
        setUploadPopupActive(false);
    };
    var inputs = [
        {
            label: en/* common.name */.y0.name,
            name: "name",
            color: "dark",
            error: errors["name"],
            register: register({
                required: en/* validation.required */.Uf.C1
            }),
            onKeyUp: handleKeyUp,
            value: formData.name,
            autoComplete: noAutofill
        },
        {
            label: en/* common.publication */.y0.publication,
            name: "publication",
            color: "dark",
            error: errors["publication"],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.publication
        },
        {
            label: en/* profile.header.details.sidebar.website */.N5.Fs.Xv.r.CF,
            name: "website",
            color: "dark",
            error: errors["website"],
            register: register({
                required: en/* validation.required */.Uf.C1,
                pattern: {
                    value: globalConstants/* WebsiteRegEx */.II,
                    message: en/* validation.website */.Uf.CF
                }
            }),
            onKeyUp: handleKeyUp,
            value: formData.website
        },
        {
            label: en/* common.email */.y0.email,
            name: "email",
            color: "dark",
            error: errors["email"],
            register: register({
                required: en/* validation.required */.Uf.C1,
                pattern: {
                    value: globalConstants/* EmailRegEx */._e,
                    message: en/* validation.email */.Uf.Do
                }
            }),
            onKeyUp: handleKeyUp,
            value: formData.email,
            autoComplete: noAutofill
        },
        {
            label: en/* common.phone */.y0.phone,
            name: "phone",
            color: "dark",
            error: errors["phone"],
            register: register({
                required: en/* validation.required */.Uf.C1
            }),
            onKeyUp: handleKeyUp,
            value: formData.phone,
            autoComplete: noAutofill
        },
        {
            label: "Employer",
            name: "employer",
            color: "dark",
            error: errors["employer"],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.employer
        },
        {
            label: "Position",
            name: "position",
            color: "dark",
            error: errors["position"],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.position
        }, 
    ];
    var handleClick = function() {
        setUploadPopupActive(true);
    };
    var button;
    if (logoPreview) {
        button = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SidescreenEditCompanyInfo_module_default()).logoWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (SidescreenEditCompanyInfo_module_default()).companyLogo,
                    src: logoPreview
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SidescreenEditCompanyInfo_module_default()).logoEdit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_EditContent/* default */.Z, {
                        data: {
                            onClick: handleClick
                        }
                    })
                })
            ]
        });
    } else {
        button = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SidescreenEditCompanyInfo_module_default()).bioLogoArea,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                data: {
                    label: null
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (SidescreenEditCompanyInfo_module_default()).bio,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Uploader_Uploader, {
                isActive: uploadPopupActive,
                croppable: false,
                forceCrop: true,
                returnFile: true,
                onCancel: handlePopupCancel,
                onSubmit: function(file) {
                    handleFile(file);
                    setUploadPopupActive(false);
                },
                allowedTypes: "images"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SidescreenEditCompanyInfo_module_default()).bioLogo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                        variant: "body",
                        className: "mb-xxs",
                        children: en/* profile.header.details.sidebar.logo */.N5.Fs.Xv.r.jY
                    }),
                    button
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SidescreenEditCompanyInfo_module_default()).bioBody,
                children: inputs.map(function(item, key) {
                    if (isJournalist) {
                        if (item.name !== "phone" || item.name === "publication" && isJournalist) {
                            return /*#__PURE__*/ (0,react.createElement)(components_Input/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                key: "input-".concat(key)
                            }));
                        }
                    } else {
                        if (item.name !== "publication") {
                            return /*#__PURE__*/ (0,react.createElement)(components_Input/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                key: "input-".concat(key)
                            }));
                        }
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_Details = (Details_Details);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_property_key.mjs + 2 modules
var _to_property_key = __webpack_require__(40136);
// EXTERNAL MODULE: ./api/newsroom.js
var newsroom = __webpack_require__(37665);
// EXTERNAL MODULE: ./api/fca.js
var fca = __webpack_require__(77615);
// EXTERNAL MODULE: ./utils/fca.js
var utils_fca = __webpack_require__(34320);
// EXTERNAL MODULE: ./styles/modules/Fca.module.scss
var Fca_module = __webpack_require__(53926);
var Fca_module_default = /*#__PURE__*/__webpack_require__.n(Fca_module);
;// CONCATENATED MODULE: ./components/Sidescreen/FcaDetails.js


















var FIELD_IDS = {
    frn: "fca-frn",
    practisingRole: "fca-role"
};
var NOTICES = {
    saved: "Saved.",
    changed: "Saved. Newspage is checking it against the FCA Register; the label shows once it matches.",
    removed: "Removed.",
    rejected: "Saved — nothing new to check."
};
var ref = (0,_sliced_to_array/* default */.Z)(utils_fca/* REJECTED_LINE.split */.P7.split("contact us"), 2), rejectedBefore = ref[0], rejectedAfter = ref[1];
var RejectedLine = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            rejectedBefore,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "mailto:".concat(utils_fca/* FCA_CONTACT_EMAIL */.p1),
                children: "contact us"
            }),
            rejectedAfter
        ]
    });
};
var describedBy = function() {
    for(var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++){
        ids[_key] = arguments[_key];
    }
    return ids.filter(Boolean).join(" ") || undefined;
};
// Saved on its own (PUT /profiles/:id/fca), apart from the rest of Edit info: a changed FRN is
// checked against the FCA Register, or goes to the admins when that can't confirm it.
var FcaDetails = function(param) {
    var profileId = param.profileId, slug = param.slug, onDirtyChange = param.onDirtyChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(null), saved = ref[0], setSaved = ref[1];
    var ref1 = (0,react.useState)((0,utils_fca/* toFcaForm */._q)(null)), form = ref1[0], setForm = ref1[1];
    var ref2 = (0,react.useState)({}), errors = ref2[0], setErrors = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(null), notice = ref4[0], setNotice = ref4[1];
    var ref5 = (0,react.useState)(false), busy = ref5[0], setBusy = ref5[1];
    var apply = function(details) {
        setSaved(details);
        setForm((0,utils_fca/* toFcaForm */._q)(details));
    };
    var dirty = Boolean(saved) && (0,utils_fca/* fcaFormDirty */.GU)(form, saved);
    (0,react.useEffect)(function() {
        onDirtyChange === null || onDirtyChange === void 0 ? void 0 : onDirtyChange(dirty);
    }, [
        dirty
    ]);
    (0,react.useEffect)(function() {
        (0,fca/* fetchFca */.kb)(profileId).then(apply).catch(function(err) {
            return setError((0,newsroom/* newsroomError */.tt)(err, "Could not load your FCA details."));
        });
    }, [
        profileId
    ]);
    var set = function(field, value) {
        setForm(function(current) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, current), (0,_define_property/* default */.Z)({}, field, value));
        });
        setNotice(null);
    };
    var edit = function(field, value) {
        set(field, value);
        setErrors(function(_param) {
            var _ = _param[field], rest = (0,_object_without_properties/* default */.Z)(_param, [
                field
            ].map(_to_property_key/* default */.Z));
            return rest;
        });
    };
    var reload = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(next) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(next === null || next === void 0 ? void 0 : next.status)) return [
                            3,
                            1
                        ];
                        _tmp = next;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            (0,fca/* fetchFca */.kb)(profileId)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        apply.apply(void 0, [
                            _tmp
                        ]);
                        // A changed or removed FRN takes any approved label off the public profile.
                        if (slug) (0,fca/* refreshProfile */.aj)(dispatch, slug);
                        return [
                            2
                        ];
                }
            });
        });
        return function reload(next) {
            return _ref.apply(this, arguments);
        };
    }();
    var persist = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(payload, changed) {
            var wasRejected, next, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        wasRejected = (saved === null || saved === void 0 ? void 0 : saved.status) === "rejected";
                        setBusy(true);
                        setError(null);
                        setNotice(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            (0,fca/* saveFca */.Zx)(profileId, payload)
                        ];
                    case 2:
                        next = _state.sent();
                        return [
                            4,
                            reload(next)
                        ];
                    case 3:
                        _state.sent();
                        // The API does not re-check an unchanged claim, so a rejected one stays rejected.
                        setNotice(changed ? "changed" : wasRejected ? "rejected" : "saved");
                        return [
                            3,
                            6
                        ];
                    case 4:
                        err = _state.sent();
                        setError((0,newsroom/* newsroomError */.tt)(err, "Could not save your FCA details."));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setBusy(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function persist(payload, changed) {
            return _ref.apply(this, arguments);
        };
    }();
    var submit = function(event) {
        event.preventDefault();
        var ref = (0,utils_fca/* validateFcaDetails */.GI)(form, saved === null || saved === void 0 ? void 0 : saved.frn), found = ref.errors, payload = ref.payload;
        setErrors(found);
        if (!payload) {
            var ref1;
            var first = Object.keys(FIELD_IDS).find(function(field) {
                return found[field];
            });
            (ref1 = document.getElementById(FIELD_IDS[first])) === null || ref1 === void 0 ? void 0 : ref1.focus();
            return;
        }
        var changed = (0,utils_fca/* statedChanged */.Am)(form, saved);
        if (!changed || (saved === null || saved === void 0 ? void 0 : saved.status) !== "approved") {
            persist(payload, changed);
            return;
        }
        dispatch((0,ux/* showPopup */.U)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "Change your FCA details?",
            body: "Your ".concat(utils_fca/* FCA_LABEL */.hx, " label comes off until we check the new details."),
            confirmTitle: "Change",
            cancelTitle: "Cancel",
            onCancel: function() {
                return dispatch((0,ux/* hidePopup */.hj)());
            },
            onConfirm: function() {
                dispatch((0,ux/* hidePopup */.hj)());
                persist(payload, changed);
            }
        }));
    };
    var remove = function() {
        dispatch((0,ux/* showPopup */.U)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "Remove your FCA details?",
            body: "The ".concat(utils_fca/* FCA_LABEL */.hx, " label comes off your profile. You can add your FRN again later."),
            confirmTitle: "Remove",
            cancelTitle: "Cancel",
            onCancel: function() {
                return dispatch((0,ux/* hidePopup */.hj)());
            },
            onConfirm: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,ux/* hidePopup */.hj)());
                            setBusy(true);
                            setError(null);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                5,
                                6
                            ]);
                            return [
                                4,
                                (0,fca/* removeFca */.nW)(profileId)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                reload(null)
                            ];
                        case 3:
                            _state.sent();
                            setErrors({});
                            setNotice("removed");
                            return [
                                3,
                                6
                            ];
                        case 4:
                            err = _state.sent();
                            setError((0,newsroom/* newsroomError */.tt)(err, "Could not remove your FCA details."));
                            return [
                                3,
                                6
                            ];
                        case 5:
                            setBusy(false);
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })
        }));
    };
    var status = saved === null || saved === void 0 ? void 0 : saved.status;
    var statusLine = (0,utils_fca/* memberStatusLine */.KH)(saved || {});
    var id = function(name) {
        return "fca-".concat(name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Fca_module_default()).section,
        "aria-labelledby": id("title"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "h4",
                Tag: "h2",
                id: id("title"),
                children: "FCA details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (Fca_module_default()).intro,
                children: [
                    "Optional and private: only you and Newspage see your FRN. Once Newspage has checked it against the FCA Register, your profile shows an ",
                    utils_fca/* FCA_LABEL */.hx,
                    " label."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Fca_module_default()).intro,
                children: utils_fca/* FCA_DIRECTORY_RULE */.qD
            }),
            statusLine && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: [
                    (Fca_module_default()).status,
                    status === "rejected" ? (Fca_module_default()).statusRejected : "", 
                ].join(" "),
                role: "status",
                children: status === "rejected" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedLine, {}) : statusLine
            }),
            error && !saved && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Fca_module_default()).error,
                role: "alert",
                children: error
            }),
            saved && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: submit,
                noValidate: true,
                className: (Fca_module_default()).form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Fca_module_default()).field,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: id("frn"),
                                children: "FCA reference number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: id("frn"),
                                type: "text",
                                inputMode: "numeric",
                                autoComplete: "off",
                                maxLength: utils_fca/* FRN_MAX */.sh + 2,
                                value: form.frn,
                                onChange: function(e) {
                                    return edit("frn", e.target.value);
                                },
                                "aria-invalid": Boolean(errors.frn),
                                "aria-describedby": describedBy(id("frn-hint"), errors.frn && id("frn-error"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Fca_module_default()).hint,
                                id: id("frn-hint"),
                                children: [
                                    "Your firm's FRN from the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://register.fca.org.uk/s/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "FCA Register"
                                    }),
                                    ". Appointed representatives: use your principal's FRN."
                                ]
                            }),
                            errors.frn && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Fca_module_default()).fieldError,
                                id: id("frn-error"),
                                children: errors.frn
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                        className: "".concat((Fca_module_default()).field, " ").concat((Fca_module_default()).choices),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                children: "Are you a practising adviser who advises clients yourself?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        name: "fca-practising",
                                        checked: form.practisingAdviser === true,
                                        onChange: function() {
                                            return set("practisingAdviser", true);
                                        }
                                    }),
                                    "Yes"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        name: "fca-practising",
                                        checked: form.practisingAdviser === false,
                                        onChange: function() {
                                            return set("practisingAdviser", false);
                                        }
                                    }),
                                    "No"
                                ]
                            })
                        ]
                    }),
                    form.practisingAdviser === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Fca_module_default()).field,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: id("role"),
                                children: "What is your role?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: id("role"),
                                type: "text",
                                maxLength: utils_fca/* ROLE_MAX */.yn,
                                value: form.practisingRole,
                                onChange: function(e) {
                                    return edit("practisingRole", e.target.value);
                                },
                                "aria-invalid": Boolean(errors.practisingRole),
                                "aria-describedby": describedBy(id("role-hint"), errors.practisingRole && id("role-error"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Fca_module_default()).hint,
                                id: id("role-hint"),
                                children: [
                                    "For example: head of marketing at an advice firm. ",
                                    form.practisingRole.length,
                                    "/",
                                    utils_fca/* ROLE_MAX */.yn
                                ]
                            }),
                            errors.practisingRole && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Fca_module_default()).fieldError,
                                id: id("role-error"),
                                children: errors.practisingRole
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Fca_module_default()).error,
                        role: "alert",
                        children: error
                    }),
                    notice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Fca_module_default()).saved,
                        role: "status",
                        children: NOTICES[notice]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Fca_module_default()).hint,
                        children: "Saved separately from the rest of Edit info."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Fca_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                                theme: "secondary",
                                title: "Save FCA details",
                                loading: busy
                            }),
                            saved.frn && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: (Fca_module_default()).textButton,
                                onClick: remove,
                                disabled: busy,
                                children: "Remove FCA details"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_FcaDetails = (FcaDetails);

;// CONCATENATED MODULE: ./components/Sidescreen/SidescreenHeader.js





var SidescreenHeader_SidescreenHeader = function(param) {
    var title = param.title, children = param.children, closeFn = param.closeFn, isEditable = param.isEditable, isAuthorized = param.isAuthorized;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleClickClose = function() {
        if (closeFn) closeFn();
        dispatch((0,ux/* handleHideSidescreen */.Qb)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: [
            (Sidescreen_module_default()).header,
            !isAuthorized && isEditable ? (Sidescreen_module_default()).headerPublic : "", 
        ].join(" "),
        children: [
            isEditable && !isAuthorized ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "h2",
                className: (Sidescreen_module_default()).title,
                children: title
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (Sidescreen_module_default()).close,
                onClick: handleClickClose,
                type: "button"
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_SidescreenHeader = (SidescreenHeader_SidescreenHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/modules/Input.module.scss
var Input_module = __webpack_require__(47909);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/Svg/Enter.js



var Enter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 26 26",
        width: "26",
        height: "26"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M25 2H9c-.551 0-1 .449-1 1v9c0 2-2 2-2 2H1c-.551 0-1 .449-1 1v8c0 .551.449 1 1 1h24c.551 0 1-.449 1-1V3c0-.551-.449-1-1-1zm-3 12c0 1.436-1.336 4-4 4h-3.586l1.793 1.793c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.5-3.5c-.391-.391-.391-1.023 0-1.414l3.5-3.5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414L14.414 16H18c1.398 0 2-1.518 2-2v-2c0-.553.447-1 1-1s1 .447 1 1v2z",
            fill: "#030104"
        })
    }));
};
/* harmony default export */ var Svg_Enter = (Enter);

// EXTERNAL MODULE: ./components/Svg/Remove.js
var Remove = __webpack_require__(6607);
// EXTERNAL MODULE: ./components/Svg/Facebook.js
var Facebook = __webpack_require__(81361);
// EXTERNAL MODULE: ./components/Svg/Twitter.js
var Twitter = __webpack_require__(15288);
// EXTERNAL MODULE: ./components/Svg/Instagram.js
var Instagram = __webpack_require__(51977);
// EXTERNAL MODULE: ./components/Svg/LinkedIn.js
var LinkedIn = __webpack_require__(26908);
// EXTERNAL MODULE: ./components/Svg/Youtube.js
var Youtube = __webpack_require__(68246);
// EXTERNAL MODULE: ./components/Svg/Tiktok.js
var Tiktok = __webpack_require__(24306);
// EXTERNAL MODULE: ./components/Svg/Mastodon.js
var Mastodon = __webpack_require__(11340);
// EXTERNAL MODULE: ./components/Svg/Threads.js
var Threads = __webpack_require__(84591);
;// CONCATENATED MODULE: ./helpers/url.js









var isUrl = function(val) {
    var urlPattern = /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    return urlPattern.test(val);
};
var isSocial = function(val, socialTypes) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = socialTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (val.includes("".concat(item, ".com")) || val.includes("".concat(item, ".social")) || val.includes("".concat(item, ".net"))) {
                if (item === "x") {
                    return "twitter";
                }
                return item;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var formatUrl = function(val) {
    val = val.trim();
    // if url begins with "//"
    if (val.substring(0, 2) === "//") {
        val = val.split("//").join("");
    }
    // if url contains "http://"
    if (val.includes("http://")) {
        val = val.split("http://").join("");
    }
    // if url contains "https://"
    if (val.includes("https://")) {
        val = val.split("https://").join("");
    }
    // if url contains "www."
    if (val.includes("www.")) {
        val = val.split("www.").join("");
    }
    // if url has attributes
    // if (val.includes('?')) {
    //     val = val.split('?')[0];
    // }
    // if url has a trailing slash
    if (val.substring(val.length - 1, val.length) === "/") {
        val = val.slice(0, -1);
    }
    return "https://".concat(val);
};
var getSocialIcon = function(name) {
    var icon;
    switch(name){
        case "facebook":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "twitter":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "instagram":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "linkedin":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "youtube":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Youtube/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "tiktok":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiktok/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "mastodon":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Mastodon/* default */.Z, {
                fill: "#212121"
            });
            break;
        case "threads":
            icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Threads/* default */.Z, {
                fill: "#212121"
            });
            break;
        default:
            icon = null;
            break;
    }
    return icon;
};


// EXTERNAL MODULE: ./components/Tick.js
var Tick = __webpack_require__(44075);
;// CONCATENATED MODULE: ./components/Sidescreen/Social.js











var Social = function(param) {
    var callback = param.callback, socialNetwork = param.socialNetwork;
    var ref = (0,react.useState)(false), hasError = ref[0], setHasError = ref[1];
    var ref1 = (0,react.useState)(false), enabledButton = ref1[0], setEnabledButton = ref1[1];
    var ref2 = (0,react.useState)(null), newLink = ref2[0], setNewLink = ref2[1];
    var ref3 = (0,react.useState)(""), val = ref3[0], setVal = ref3[1];
    var socialTypes = [
        "facebook",
        "instagram",
        "linkedin",
        "twitter",
        "youtube",
        "tiktok",
        "mastodon",
        "threads",
        "x", 
    ];
    var hasSocialType = function(type) {
        var filtered = socialNetwork.filter(function(item) {
            return item.name === type;
        });
        return filtered.length > 0;
    };
    var handleKeyDown = function(e) {
        var ref;
        var key = (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if (key === "enter") {
            e.preventDefault();
            var val = e.target.value;
            var social = isSocial(val, socialTypes);
            if (!isUrl(val) || !social || hasSocialType(social)) {
                setHasError(true);
                return null;
            }
            handleSubmit(e);
        }
    };
    var handleKeyUp = function(name, e) {
        var ref;
        var value = e.target.value;
        var key = (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        setVal(value);
        if (key === "enter") return null;
        if (value && value.trim() !== "") {
            var social = isSocial(value, socialTypes);
            if (!isUrl(value) || !social || hasSocialType(social)) {
                setHasError(true);
                setNewLink(null);
                return null;
            }
            var formattedValue = formatUrl(value);
            setEnabledButton(true);
            setNewLink({
                name: social,
                url: formattedValue
            });
            setHasError(false);
        } else {
            setNewLink(null);
            setEnabledButton(false);
            setHasError(false);
        }
    };
    var handleChange = function(e) {
        var val = e.target.value;
        setVal(val);
        var social = isSocial(val, socialTypes);
        if (!isUrl(val) || !social || hasSocialType(social)) {
            setHasError(true);
            return null;
        }
        var value = formatUrl(val);
        setEnabledButton(true);
        setNewLink({
            name: social,
            url: value
        });
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        callback((0,src_to_consumable_array/* default */.Z)(socialNetwork).concat([
            newLink
        ]));
        setVal("");
        setNewLink(null);
        setEnabledButton(false);
    };
    var handleRemove = function(name) {
        var tmp = socialNetwork.filter(function(item) {
            return item.name !== name;
        });
        callback((0,src_to_consumable_array/* default */.Z)(tmp));
    };
    var linksItems = socialNetwork.map(function(item, key) {
        if (!item.url) return null;
        var icon = getSocialIcon(item.name);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SidescreenEditCompanyInfo_module_default()).socialItem,
            children: [
                icon,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: item.url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (SidescreenEditCompanyInfo_module_default()).remove,
                    onClick: function() {
                        return handleRemove(item.name);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                })
            ]
        }, "link-".concat(key));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SidescreenEditCompanyInfo_module_default()).social,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "body",
                className: "mb-xxs",
                children: en/* profile.header.details.sidebar.social_links */.N5.Fs.Xv.r.FK
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SidescreenEditCompanyInfo_module_default()).socialNetwork,
                children: linksItems
            }),
            socialTypes.length > socialNetwork.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SidescreenEditCompanyInfo_module_default()).inputWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            (Input_module_default()).inputWrapper,
                            hasError ? (Input_module_default()).inputWrapperError : null, 
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SidescreenEditCompanyInfo_module_default()).liveSocial,
                                children: getSocialIcon(newLink === null || newLink === void 0 ? void 0 : newLink.name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: [
                                    (SidescreenEditCompanyInfo_module_default()).enter,
                                    newLink ? (SidescreenEditCompanyInfo_module_default()).enterActive : "", 
                                ].join(" "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Enter, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "socialLink",
                                name: "socialLink",
                                type: "text",
                                className: (Input_module_default()).input,
                                value: val,
                                placeholder: en/* profile.header.details.sidebar.social_link_placeholder */.N5.Fs.Xv.r.hc,
                                onKeyDown: handleKeyDown,
                                onChange: handleChange,
                                onKeyUp: function(e) {
                                    handleKeyUp("socialLink", e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tick/* default */.Z, {
                        onClick: handleSubmit,
                        disabled: !enabledButton,
                        className: (SidescreenEditCompanyInfo_module_default()).tick
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_Social = (Social);

;// CONCATENATED MODULE: ./components/Sidescreen/EditCompanyInfo.js





















var EditCompanyInfo = function(param) {
    var onUpdate = param.onUpdate, title = param.title, isJournalist = param.isJournalist;
    var dispatch = (0,es/* useDispatch */.I0)();
    var data = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX).data;
    var company = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).company;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.errors;
    var ref1 = (0,react.useState)(null), companyLogo = ref1[0], setCompanyLogo = ref1[1];
    var ref2 = (0,react.useState)(false), fcaDirty = ref2[0], setFcaDirty = ref2[1];
    var ref3 = (0,react.useState)(data.logo ? data.logo.path : null), companyLogoPreview = ref3[0], setCompanyLogoPreview = ref3[1];
    var ref4 = (0,react.useState)({
        details: {
            name: data.name,
            website: data.website,
            email: data.email,
            phone: data.phone,
            publication: data.publication,
            logo: data.logo && data.logo.path,
            employer: data.employer,
            position: data.position
        },
        socialNetwork: data.socialNetwork,
        description: data.description,
        logo: data.logo && data.logo.path
    }), formData = ref4[0], setFormData = ref4[1];
    var handleDetails = function(details) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            details: details
        }));
    };
    var handleSocial = function(socialNetwork) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            socialNetwork: socialNetwork
        }));
    };
    var handleDescription = function(description) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            description: description
        }));
    };
    var handleFile = function(file) {
        setCompanyLogo(file.file);
        setCompanyLogoPreview(file.src);
    };
    var handleFileUpload = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var formData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!companyLogo) {
                    if (onUpdate) {
                        return [
                            2,
                            onUpdate()
                        ];
                    }
                    return [
                        2,
                        null
                    ];
                }
                formData = new FormData();
                formData.append("logo", companyLogo);
                dispatch((0,store_company/* addLogo */.gi)(formData));
                if (!data.loading && onUpdate) {
                    onUpdate();
                }
                return [
                    2
                ];
            });
        });
        return function handleFileUpload() {
            return _ref.apply(this, arguments);
        };
    }();
    var save = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var details, description, socialNetwork;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        details = formData.details, description = formData.description, socialNetwork = formData.socialNetwork;
                        dispatch((0,store_company/* updateCompanyById */.V8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, details), {
                            description: description,
                            socialNetwork: socialNetwork
                        })));
                        return [
                            4,
                            handleFileUpload()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    // Saving the rest closes the side screen, which would silently drop unsaved FCA edits.
    var confirmFcaDiscard = function(proceed) {
        if (!fcaDirty) return proceed();
        dispatch((0,ux/* showPopup */.U)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "Your FCA details are not saved",
            body: "They save separately, with Save FCA details. Save the rest and discard the FCA changes?",
            confirmTitle: "Discard FCA changes",
            cancelTitle: "Keep editing",
            onCancel: function() {
                return dispatch((0,ux/* hidePopup */.hj)());
            },
            onConfirm: function() {
                dispatch((0,ux/* hidePopup */.hj)());
                proceed();
            }
        }));
    };
    var handleFormSubmit = function(e) {
        e.preventDefault();
        confirmFcaDiscard(confirmContactChange);
    };
    var confirmContactChange = function() {
        var changed = [
            "email",
            "phone"
        ].filter(function(field) {
            return (data[field] || "") !== (formData.details[field] || "");
        });
        if (data.slug === company || !changed.length) {
            return save();
        }
        dispatch((0,ux/* showPopup */.U)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "Change ".concat(data.name, "'s contact details?"),
            body: changed.map(function(field) {
                return "".concat(en/* common */.y0[field], ": ").concat((0,safe_html/* escapeHtml */.Xv)(data[field] || "none"), " → ").concat((0,safe_html/* escapeHtml */.Xv)(formData.details[field] || "none"));
            }).join("<br>"),
            confirmTitle: en/* common.save */.y0.save,
            cancelTitle: "Cancel",
            onCancel: function() {
                return dispatch((0,ux/* hidePopup */.hj)());
            },
            onConfirm: function() {
                dispatch((0,ux/* hidePopup */.hj)());
                save();
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: function(e) {
                    return handleSubmit(handleFormSubmit(e));
                },
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_SidescreenHeader, {
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_Details, {
                        callback: handleDetails,
                        register: register,
                        errors: errors,
                        data: formData.details,
                        handleFile: handleFile,
                        logoPreview: companyLogoPreview,
                        isJournalist: isJournalist
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_Social, {
                        socialNetwork: formData.socialNetwork,
                        callback: function(val) {
                            return handleSocial(val);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitedTextArea/* default */.Z, {
                        isJournalist: isJournalist,
                        callback: function(val) {
                            return handleDescription(val);
                        },
                        register: register,
                        errors: errors,
                        value: formData.description,
                        description: isJournalist ? en/* profile.header.details.sidebar.description_journalist */.N5.Fs.Xv.r.mn : en/* profile.header.details.sidebar.description */.N5.Fs.Xv.r.WL,
                        limit: 1200
                    }),
                    !isJournalist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typo/* default */.Z, {
                        variant: "small",
                        Tag: "p",
                        className: "mt-xxxs",
                        children: [
                            "Start your About with one sentence like this:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "Full name"
                            }),
                            " is ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "position"
                            }),
                            " and a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "your job, e.g. mortgage broker, HR adviser, currency specialist"
                            }),
                            " ",
                            "at ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "firm"
                            }),
                            ", based in ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "town or city"
                            }),
                            ". For example: “Jane Example is Managing Director and a mortgage broker at Example Mortgages, based in Leeds.” We add your media coverage count to the end of that sentence automatically."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                        title: en/* common.save */.y0.save,
                        loading: data.loading,
                        sticky: {
                            position: "bottom"
                        }
                    })
                ]
            }),
            !isJournalist && data.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_FcaDetails, {
                        profileId: data.id,
                        slug: data.slug,
                        onDirtyChange: setFcaDirty
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_EditCompanyInfo = (EditCompanyInfo);

;// CONCATENATED MODULE: ./components/Sidescreen/addExpert/Details.js















var addExpert_Details_Details = function(param) {
    var callback = param.callback, register = param.register, errors = param.errors, picturePreview = param.picturePreview, data = param.data, handleFile = param.handleFile, isEditable = param.isEditable;
    var ref;
    var isAuthorized = useSelector(authSelector).isAuthorized;
    var ref1 = useState(data !== null && data !== void 0 ? data : null), formData = ref1[0], setFormData = ref1[1];
    var ref2 = useState(false), uploadPopupActive = ref2[0], setUploadPopupActive = ref2[1];
    var handleKeyUp = function(name, val) {
        var newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);
        callback(newFormData);
    };
    var inputs = [
        {
            label: common.name,
            name: "name",
            color: "dark",
            error: errors["name"],
            register: register({
                required: validation.required
            }),
            onKeyUp: handleKeyUp,
            value: (formData === null || formData === void 0 ? void 0 : formData.name) ? formData === null || formData === void 0 ? void 0 : formData.name : ""
        },
        {
            label: profile.header.experts.sidebar.position,
            name: "position",
            color: "dark",
            error: errors["position"],
            register: register,
            onKeyUp: handleKeyUp,
            value: (formData === null || formData === void 0 ? void 0 : formData.position) ? formData === null || formData === void 0 ? void 0 : formData.position : ""
        },
        {
            label: common.email,
            name: "email",
            color: "dark",
            error: errors["email"],
            register: register({
                pattern: {
                    value: EmailRegEx,
                    message: validation.email
                }
            }),
            onKeyUp: handleKeyUp,
            value: (formData === null || formData === void 0 ? void 0 : formData.email) ? formData === null || formData === void 0 ? void 0 : formData.email : ""
        },
        {
            label: common.phone,
            name: "phone",
            color: "dark",
            error: errors["phone"],
            register: register,
            onKeyUp: handleKeyUp,
            value: (formData === null || formData === void 0 ? void 0 : formData.phone) ? formData === null || formData === void 0 ? void 0 : formData.phone : ""
        }, 
    ];
    var handleClick = function() {
        setUploadPopupActive(true);
    };
    var handlePopupCancel = function() {
        setUploadPopupActive(false);
    };
    var button = null;
    if (picturePreview || ((ref = formData.image) === null || ref === void 0 ? void 0 : ref.path)) {
        var ref3, ref4;
        button = /*#__PURE__*/ _jsxs("div", {
            className: [
                styles.logoWrapper,
                !isAuthorized && isEditable ? styles.logoWrapperPublic : "", 
            ].join(" "),
            children: [
                /*#__PURE__*/ _jsx("img", {
                    className: styles.companyLogo,
                    src: (formData === null || formData === void 0 ? void 0 : (ref3 = formData.image) === null || ref3 === void 0 ? void 0 : ref3.path) !== "" && picturePreview ? picturePreview : formData === null || formData === void 0 ? void 0 : (ref4 = formData.image) === null || ref4 === void 0 ? void 0 : ref4.path
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.logoEdit,
                    children: /*#__PURE__*/ _jsx(EditContent, {
                        data: {
                            onClick: handleClick
                        }
                    })
                })
            ]
        });
    } else {
        button = /*#__PURE__*/ _jsx("div", {
            className: styles.bioLogoArea,
            onClick: handleClick,
            children: /*#__PURE__*/ _jsx(AddContent, {
                data: {
                    label: null
                }
            })
        });
    }
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.bio,
        children: [
            /*#__PURE__*/ _jsx(Uploader, {
                isActive: uploadPopupActive,
                croppable: true,
                returnFile: true,
                onCancel: handlePopupCancel,
                onSubmit: function(file) {
                    handleFile(file);
                    setUploadPopupActive(false);
                },
                allowedTypes: "images"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.bioLogo,
                children: [
                    isAuthorized && /*#__PURE__*/ _jsx(Typo, {
                        variant: "body",
                        className: "mb-xxs",
                        children: profile.header.experts.sidebar.picture
                    }),
                    button
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.bioBody,
                children: inputs.map(function(item, key) {
                    return /*#__PURE__*/ _createElement(Input, _object_spread_props(_object_spread({}, item), {
                        key: "input-".concat(key)
                    }));
                })
            })
        ]
    });
};
/* harmony default export */ var addExpert_Details = ((/* unused pure expression or super */ null && (addExpert_Details_Details)));

;// CONCATENATED MODULE: ./components/Sidescreen/addExpert/Description.js



// import styles from 'styles/modules/SidescreenAddExpert.module.scss';




var Description_Description = function(props) {
    var isAuthorized = useSelector(authSelector).isAuthorized;
    var ref = useState(props.description || ""), val = ref[0], setVal = ref[1];
    var handleChange = function(e) {
        setVal(e.target.value);
        if (props.callback) {
            props.callback(e.target.value);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.description,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: [
                    "mb-xxs",
                    styles.descriptionHeader
                ].join(" "),
                children: /*#__PURE__*/ _jsx(Typo, {
                    variant: "body",
                    Tag: "label",
                    htmlFor: "description",
                    children: isAuthorized ? profile.header.experts.sidebar.bio : profile.header.experts.sidebar.bio_public
                })
            }),
            /*#__PURE__*/ _jsx("textarea", {
                name: "description",
                id: "description",
                className: styles.descriptionTextarea,
                onChange: handleChange,
                defaultValue: val
            })
        ]
    });
};
/* harmony default export */ var addExpert_Description = ((/* unused pure expression or super */ null && (Description_Description)));

;// CONCATENATED MODULE: ./components/Sidescreen/addExpert/AddContent.js



var AddContent_AddContent = function(props) {
    var data = {
        direction: "column",
        label: "Add Content",
        onClick: function() {},
        active: false,
        center: false
    };
    if (props.data) data = _object_spread({}, data, props.data);
    var wantedClasses = [
        styles.wrapper,
        styles[data.direction],
        data.active ? styles.active : null,
        !data.label ? styles.inline : null,
        data.center ? styles.center : null, 
    ].join(" ");
    return /*#__PURE__*/ _jsxs("div", {
        className: wantedClasses,
        onClick: data.onClick,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.plus
            }),
            data.label && /*#__PURE__*/ _jsx("div", {
                className: styles.label,
                children: data.label
            })
        ]
    });
};
/* harmony default export */ var addExpert_AddContent = ((/* unused pure expression or super */ null && (AddContent_AddContent)));

// EXTERNAL MODULE: ./components/ExpertiseDropdown.js + 1 modules
var components_ExpertiseDropdown = __webpack_require__(25680);
// EXTERNAL MODULE: ./components/Tags.js
var components_Tags = __webpack_require__(58632);
// EXTERNAL MODULE: ./store/expertise.js
var expertise = __webpack_require__(781);
;// CONCATENATED MODULE: ./components/Sidescreen/addExpert/Expertise.js














var Expertise_Expertise = function(param) {
    var update = param.update, data = param.data;
    var isAuthorized = useSelector(authSelector).isAuthorized;
    var dispatch = useDispatch();
    var globalExpertise = useSelector(expertiseSelector);
    var ref = useState(7), limit = ref[0], setLimit = ref[1];
    var ref1 = useState(false), activeAdder = ref1[0], setActiveAdder = ref1[1];
    // TODO: split this file into smaller parts
    var ref2 = useState(data), activeTags = ref2[0], setActivetags = ref2[1];
    useEffect(function() {
        if (!globalExpertise.data) {
            dispatch(fetchExpertise());
        }
    }, []);
    useEffect(function() {
        setActivetags(data);
    }, [
        data
    ]);
    var addTag = function(item) {
        if (!activeTags.includes(item)) {
            setActivetags(_to_consumable_array(activeTags).concat([
                item
            ]));
            setLimit(limit + 1);
            update(_to_consumable_array(activeTags).concat([
                item
            ]));
        }
    };
    var removeTag = function(item) {
        if (activeTags.includes(item)) {
            var active = activeTags.filter(function(tag) {
                return tag !== item;
            });
            setActivetags(active);
            setLimit(limit - 1);
            update(active);
        }
    };
    var expertiseList = /*#__PURE__*/ _jsx(Tags, {
        disabled: true,
        data: {
            allTags: globalExpertise.data ? globalExpertise.data : [],
            activeTags: activeTags,
            onClick: function(tag) {
                removeTag(tag);
            },
            limit: limit
        }
    });
    var adderRef = /*#__PURE__*/ React.createRef();
    useEffect(function() {
        var handleClickOutside = function(e) {
            if (activeAdder && adderRef && !adderRef.current.contains(e.target)) {
                setActiveAdder(false);
            }
        };
        document.addEventListener("mouseup", handleClickOutside);
        return function cleanup() {
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, []);
    var dropdownData = {
        name: "expertise",
        inline: false,
        items: globalExpertise.data ? globalExpertise.data : [],
        exclude: activeTags,
        callback: function(item) {
            addTag(item);
        }
    };
    if (!activeAdder) {
        dropdownData = _object_spread_props(_object_spread({}, dropdownData), {
            query: "",
            showList: false
        });
    }
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-xxs",
                children: /*#__PURE__*/ _jsxs(Typo, {
                    variant: "body",
                    Tag: "label",
                    htmlFor: "",
                    children: [
                        isAuthorized ? profile.header.experts.sidebar.expertise : profile.header.expertise.title,
                        ":"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.expertise,
                children: /*#__PURE__*/ _jsxs("aside", {
                    className: styles.list,
                    ref: adderRef,
                    children: [
                        expertiseList,
                        isAuthorized && /*#__PURE__*/ _jsxs("div", {
                            className: [
                                styles.addTag,
                                activeAdder ? styles.addTagActive : null, 
                            ].join(" "),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.dropdown,
                                    children: /*#__PURE__*/ _jsx(ExpertiseDropdown, {
                                        data: dropdownData
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.add,
                                    children: /*#__PURE__*/ _jsx(AddContent, {
                                        data: {
                                            direction: "row",
                                            label: !activeAdder && activeTags.length < 1 ? "Add Expertise" : null,
                                            active: activeAdder,
                                            onClick: function() {
                                                setActiveAdder(!activeAdder);
                                            }
                                        }
                                    })
                                }),
                                limit < (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ _jsx("button", {
                                    onClick: function() {
                                        return setLimit(activeTags === null || activeTags === void 0 ? void 0 : activeTags.length);
                                    },
                                    className: [
                                        styles.loadMore
                                    ],
                                    children: "+".concat((data === null || data === void 0 ? void 0 : data.length) - limit, " more")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var addExpert_Expertise = ((/* unused pure expression or super */ null && (Expertise_Expertise)));

// EXTERNAL MODULE: ./store/company/expert.js
var expert = __webpack_require__(17390);
;// CONCATENATED MODULE: ./components/Sidescreen/AddExpert.js


















var ExpertSlider = function(param) {
    var isEdit = param.isEdit, onUpdate = param.onUpdate, title = param.title;
    var dispatch = useDispatch();
    var isAuthorized = useSelector(authSelector).isAuthorized;
    var ref = useSelector(expertSelector), loading = ref.loading, data = ref.data, expert = ref.expert;
    var ref1 = useForm(), register = ref1.register, handleSubmit = ref1.handleSubmit, errors = ref1.errors;
    var ref2 = useState(null), picture = ref2[0], setPicture = ref2[1];
    var ref3 = useState(null), picturePreview = ref3[0], setPicturePreview = ref3[1];
    var ref4 = useState([]), expertise = ref4[0], setExpertise = ref4[1];
    var ref5 = useState({
        details: {}
    }), formData = ref5[0], setFormData = ref5[1];
    useEffect(function() {
        if (!loading && expert && isEdit) {
            setFormData({
                details: _object_spread({}, expert)
            });
            setExpertise(expert.expertise);
        }
    }, [
        expert
    ]);
    var handleDetails = function(details) {
        setFormData(_object_spread_props(_object_spread({}, formData), {
            details: details
        }));
    };
    var handleDescription = function(description) {
        setFormData(_object_spread_props(_object_spread({}, formData), {
            description: description
        }));
    };
    var handleFormSubmit = function(e) {
        expert ? handleUpdateExpert() : handleAddExpert();
    };
    var handleUpdateExpert = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleFileUpload()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch(updateExpert(_object_spread_props(_object_spread({}, formData.details), {
                                bio: formData.description,
                                expertise: expertise
                            })))
                        ];
                    case 2:
                        _state.sent();
                        if (onUpdate) {
                            onUpdate();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateExpert() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddExpert = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch(addExpert(_object_spread_props(_object_spread({}, formData.details), {
                                bio: formData.description,
                                expertise: expertise
                            })))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            handleFileUpload()
                        ];
                    case 2:
                        _state.sent();
                        if (onUpdate) {
                            onUpdate("Expert");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddExpert() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFile = function(file) {
        setPicture(file.file);
        setPicturePreview(file.src);
    };
    var handleFileUpload = function() {
        var _ref = _async_to_generator(function() {
            var formData;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!picture) {
                            if (onUpdate) {
                                return [
                                    2,
                                    onUpdate()
                                ];
                            }
                            return [
                                2,
                                null
                            ];
                        }
                        formData = new FormData();
                        formData.append("image", picture);
                        return [
                            4,
                            dispatch(addExpertImage(formData))
                        ];
                    case 1:
                        _state.sent();
                        if (!loading && onUpdate) {
                            onUpdate();
                        }
                        setPicturePreview(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFileUpload() {
            return _ref.apply(this, arguments);
        };
    }();
    var preTitle = isEdit ? "Edit" : "Add";
    return /*#__PURE__*/ _jsx(Fragment, {
        children: /*#__PURE__*/ _jsxs("form", {
            onSubmit: handleSubmit(handleFormSubmit),
            autoComplete: "off",
            children: [
                /*#__PURE__*/ _jsx(SidescreenHeader, {
                    title: isAuthorized ? "".concat(preTitle, " ").concat(title) : title,
                    isAuthorized: isAuthorized,
                    isEditable: isEdit
                }),
                /*#__PURE__*/ _jsx(Details, {
                    callback: handleDetails,
                    register: register,
                    errors: errors,
                    data: expert ? expert : formData.details,
                    handleFile: handleFile,
                    picturePreview: picturePreview,
                    isEditable: isEdit,
                    experts: data
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsx(Description, {
                    callback: handleDescription,
                    register: register,
                    errors: errors,
                    description: expert ? expert.bio : formData.details.bio
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsx(Expertise, {
                    data: _to_consumable_array(expertise),
                    update: setExpertise
                }),
                isAuthorized && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(Button, {
                            title: common.save,
                            loading: loading,
                            sticky: {
                                position: "bottom"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AddExpert = ((/* unused pure expression or super */ null && (ExpertSlider)));

// EXTERNAL MODULE: ./store/company/coverage.js
var coverage = __webpack_require__(57202);
// EXTERNAL MODULE: ./styles/modules/SidescreenAddMediaC.module.scss
var SidescreenAddMediaC_module = __webpack_require__(66919);
var SidescreenAddMediaC_module_default = /*#__PURE__*/__webpack_require__.n(SidescreenAddMediaC_module);
// EXTERNAL MODULE: ./styles/modules/mediaCoverage/Input.module.scss
var mediaCoverage_Input_module = __webpack_require__(48181);
var mediaCoverage_Input_module_default = /*#__PURE__*/__webpack_require__.n(mediaCoverage_Input_module);
;// CONCATENATED MODULE: ./components/Sidescreen/addMediaCoverage/Input.js




var Input_Input = function(props) {
    var ref = (0,react.useState)(props.description || ""), val = ref[0], setVal = ref[1];
    var handleChange = function(e) {
        setVal(e.target.value);
        if (props.callback) {
            props.callback(e.target.value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (mediaCoverage_Input_module_default()).description,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "description",
                className: (mediaCoverage_Input_module_default()).descriptionLabel,
                children: en/* profile.media_coverage.sidebar.link */.N5.iT.rc.p4
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                name: "description",
                className: (mediaCoverage_Input_module_default()).descriptionTextarea,
                onChange: handleChange,
                value: val
            })
        ]
    });
};
/* harmony default export */ var addMediaCoverage_Input = (Input_Input);

;// CONCATENATED MODULE: ./components/Sidescreen/addMediaCoverage/Description.js





var addMediaCoverage_Description_Description = function(param) {
    var description = param.description, callback = param.callback;
    var ref = (0,react.useState)(description || ""), val = ref[0], setVal = ref[1];
    var handleChange = function(e) {
        setVal(e.target.value);
        if (callback) {
            callback(e.target.value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-xxxs ml-xxxs mr-xxxs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "body",
                Tag: "label",
                htmlFor: "description",
                className: "mt-xs mb-xs",
                children: en/* profile.media_coverage.sidebar.coverage_text */.N5.iT.rc.Qh
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                name: "description",
                id: "description",
                className: (SidescreenEditCompanyInfo_module_default()).descriptionTextarea,
                onChange: handleChange,
                value: val
            })
        ]
    });
};
/* harmony default export */ var addMediaCoverage_Description = (addMediaCoverage_Description_Description);

;// CONCATENATED MODULE: ./components/Sidescreen/addMediaCoverage/Details.js








var addMediaCoverage_Details_Details = function(props) {
    var callback = props.callback, register = props.register, errors = props.errors;
    var ref = (0,react.useState)(props.data), formData = ref[0], setFormData = ref[1];
    var handleKeyUp = function(name, val) {
        var newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);
        callback(newFormData);
    };
    var inputs = [
        {
            label: en/* profile.media_coverage.sidebar.coverage_source */.N5.iT.rc.v8,
            name: "source",
            color: "dark",
            error: errors["source"],
            register: register({
                required: en/* validation.required */.Uf.C1
            }),
            onKeyUp: handleKeyUp,
            value: formData.source
        },
        {
            label: en/* profile.media_coverage.sidebar.coverage_title */.N5.iT.rc.wY,
            name: "title",
            color: "dark",
            error: errors["title"],
            register: register({
                required: en/* validation.required */.Uf.C1
            }),
            onKeyUp: handleKeyUp,
            value: formData.title
        },
        {
            label: en/* profile.media_coverage.sidebar.coverage_url */.N5.iT.rc.Xp,
            name: "url",
            color: "dark",
            error: errors["url"],
            register: register({
                required: en/* validation.required */.Uf.C1
            }),
            onKeyUp: handleKeyUp,
            value: formData.url
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (SidescreenAddMediaC_module_default()).bio,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SidescreenAddMediaC_module_default()).bioBody,
            children: inputs.map(function(item, key) {
                return /*#__PURE__*/ (0,react.createElement)(components_Input/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                    key: "input-".concat(key)
                }));
            })
        })
    });
};
/* harmony default export */ var addMediaCoverage_Details = (addMediaCoverage_Details_Details);

// EXTERNAL MODULE: ./styles/modules/mediaCoverage/CoveragePreview.module.scss
var CoveragePreview_module = __webpack_require__(11285);
var CoveragePreview_module_default = /*#__PURE__*/__webpack_require__.n(CoveragePreview_module);
;// CONCATENATED MODULE: ./components/Sidescreen/addMediaCoverage/CoveragePreview.js



var CoveragePreview = function(param) {
    var isLoaded = param.isLoaded, isEditable = param.isEditable, source = param.source, title = param.title, body = param.body, isUrlEmpty = param.isUrlEmpty;
    var isTitleAndBodyEmpty = !title && !body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            "border-gray",
            (CoveragePreview_module_default()).item
        ].join(" "),
        children: isLoaded || isEditable ? isTitleAndBodyEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (CoveragePreview_module_default()).errorMessage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                variant: "small",
                children: "There was an error getting data from this page. This will need to be done manually."
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                    variant: "special",
                    className: "mb-xs",
                    children: source
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                    variant: "caption",
                    className: [
                        "mb-xxxs",
                        (CoveragePreview_module_default()).title
                    ].join(" "),
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                    variant: "small",
                    className: (CoveragePreview_module_default()).body,
                    children: body
                })
            ]
        }) : isUrlEmpty && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CoveragePreview_module_default()).loaderWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CoveragePreview_module_default()).loader
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typo/* default */.Z, {
                    variant: "small",
                    className: "mt-xxs",
                    children: [
                        "generating ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " preview"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var addMediaCoverage_CoveragePreview = (CoveragePreview);

;// CONCATENATED MODULE: ./utils/coverage-form.js
// The add-coverage form is populated by scraping the pasted article URL, and
// outlets increasingly bot-block that scrape. Both transitions live here so a
// failed scrape can never leave the previous article's publisher, headline and
// description sitting in the form to be saved against the new URL. The pasted
// URL is the one value we always have, so it is the fallback.


var coverageFormDetails = function(prev, pastedUrl, coverage) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
        details: {
            title: (coverage === null || coverage === void 0 ? void 0 : coverage.title) || "",
            source: (coverage === null || coverage === void 0 ? void 0 : coverage.publisher) || "",
            url: (coverage === null || coverage === void 0 ? void 0 : coverage.url) || pastedUrl || ""
        },
        description: (coverage === null || coverage === void 0 ? void 0 : coverage.description) || ""
    });
};

// EXTERNAL MODULE: ./components/Svg/ArrowDown.js
var ArrowDown = __webpack_require__(87878);
// EXTERNAL MODULE: ./components/OptionSelect.js
var OptionSelect = __webpack_require__(35270);
;// CONCATENATED MODULE: ./components/Sidescreen/AddMediaCoverage.js























var AddMediaCoverage = function(param) {
    var onUpdate = param.onUpdate, title = param.title;
    var dispatch = (0,es/* useDispatch */.I0)();
    var respondedAlerts = (0,es/* useSelector */.v9)(coverage/* coveragesSelector */.NQ).respondedAlerts;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.errors;
    var ref1 = (0,react.useState)(false), isLoaded = ref1[0], setIisLoaded = ref1[1];
    var ref2 = (0,react.useState)(false), isUrlSet = ref2[0], setIsUrlSet = ref2[1];
    var ref3 = (0,react.useState)(false), isEditable = ref3[0], setIsEditable = ref3[1];
    var ref4 = (0,react.useState)(false), mediaFetched = ref4[0], setMediaFetched = ref4[1];
    var ref5 = (0,react.useState)([]), alertsSelected = ref5[0], setAlertsSelected = ref5[1];
    var ref6 = (0,react.useState)(""), alertLink = ref6[0], setAlertLink = ref6[1];
    var ref7 = (0,react.useState)(null), alertLinkError = ref7[0], setAlertLinkError = ref7[1];
    // Pending link lookup, resolving to its alert id (null on error). A newer
    // link replaces it, so a late response is ignored.
    var alertLinkRequest = (0,react.useRef)(null);
    var submitting = (0,react.useRef)(false);
    // Bumped once per completed scrape, to remount the manual fields — they read
    // their props only on mount. It must never track what is being typed, or the
    // field remounts on every keystroke and loses focus.
    var ref8 = (0,react.useState)(0), scrapeSeq = ref8[0], setScrapeSeq = ref8[1];
    var ref9 = (0,react.useState)({
        details: {
            title: "",
            source: "",
            url: ""
        },
        description: "",
        title: "",
        publisher: "",
        coverageUrl: ""
    }), formData = ref9[0], setFormData = ref9[1];
    (0,react.useEffect)(function() {
        dispatch((0,coverage/* fetchRespondedAlerts */.mH)());
    }, []);
    var handleDetails = function(details) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            details: details
        }));
    };
    var handleDescription = function(description) {
        setFormData((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formData), {
            description: description
        }));
    };
    var handleUrl = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(coverageUrl) {
            var result, scraped;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!coverageUrl) {
                            return [
                                2,
                                null
                            ];
                        }
                        setIisLoaded(false);
                        setIsUrlSet(coverageUrl);
                        return [
                            4,
                            dispatch((0,coverage/* checkCoverage */.N2)(coverageUrl))
                        ];
                    case 1:
                        result = _state.sent();
                        scraped = coverage/* checkCoverage.fulfilled.match */.N2.fulfilled.match(result) ? result.payload : null;
                        // Seed the form from the thunk result rather than from a `coverage` effect.
                        // The manual fields only read their props when they mount, so they are
                        // remounted by `scrapeSeq` below — and an effect would land a render later
                        // than that remount, which would remount them with an empty form and then
                        // never reach them again. Setting both here keeps them in one commit.
                        //
                        // `scraped` is null when the outlet blocked us, which clears the previous
                        // article rather than leaving it to be saved against this URL.
                        setFormData(function(prev) {
                            return coverageFormDetails(prev, coverageUrl, scraped);
                        });
                        setMediaFetched(!!scraped);
                        setScrapeSeq(function(n) {
                            return n + 1;
                        });
                        setIisLoaded(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUrl(coverageUrl) {
            return _ref.apply(this, arguments);
        };
    }();
    var addAlert = function(param) {
        var id = param.id, value = param.value;
        return setAlertsSelected(function(alerts) {
            return alerts.some(function(alert) {
                return alert.id === id;
            }) ? alerts : (0,src_to_consumable_array/* default */.Z)(alerts).concat([
                {
                    id: id,
                    value: value
                }
            ]);
        });
    };
    var removeAlert = function(id) {
        return setAlertsSelected(function(alerts) {
            return alerts.filter(function(alert) {
                return alert.id !== id;
            });
        });
    };
    var handleAlertLink = function(link) {
        if (!link.trim()) {
            alertLinkRequest.current = null;
            setAlertLinkError(null);
            return;
        }
        var request = dispatch((0,coverage/* resolveAlertByLink */.EL)(link)).then(function(result) {
            if (alertLinkRequest.current !== request) {
                return null;
            }
            // Kept pending on error: Continue must not publish while the link
            // the admin pasted shows as not found.
            if (coverage/* resolveAlertByLink.rejected.match */.EL.rejected.match(result)) {
                setAlertLinkError(en/* profile.media_coverage.sidebar.coverage_alert_link_error */.N5.iT.rc.FG);
                return null;
            }
            alertLinkRequest.current = null;
            setAlertLink("");
            setAlertLinkError(null);
            addAlert({
                id: result.payload.id,
                value: result.payload.title
            });
            return result.payload.id;
        });
        alertLinkRequest.current = request;
    };
    var handleFormSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
            var linkedId, _tmp, alertIds;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (submitting.current) {
                            return [
                                2
                            ];
                        }
                        submitting.current = true;
                        if (!alertLinkRequest.current) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            alertLinkRequest.current
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = undefined;
                        _state.label = 3;
                    case 3:
                        linkedId = _tmp;
                        if (linkedId === null) {
                            submitting.current = false;
                            return [
                                2
                            ];
                        }
                        alertIds = (0,src_to_consumable_array/* default */.Z)(new Set((0,src_to_consumable_array/* default */.Z)(alertsSelected.map(function(param) {
                            var id = param.id;
                            return id;
                        })).concat([
                            linkedId
                        ]))).filter(Boolean);
                        dispatch((0,coverage/* addCoverage */.dm)((0,src_object_spread/* default */.Z)({
                            publisher: formData.details.source,
                            title: formData.details.title,
                            url: formData.details.url,
                            description: formData.description
                        }, alertIds.length > 1 ? {
                            alertIds: alertIds
                        } : {
                            alertId: alertIds[0]
                        })));
                        if (onUpdate) {
                            onUpdate("Media Coverage");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFormSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var alertOptions = (respondedAlerts || []).filter(function(param) {
        var id = param.id;
        return !alertsSelected.some(function(alert) {
            return alert.id === id;
        });
    }).map(function(param) {
        var id = param.id, title = param.title;
        return {
            id: id,
            name: title
        };
    });
    var showManualEdit = function() {
        setIsEditable(!isEditable);
        setIsUrlSet(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_SidescreenHeader, {
                title: title,
                closeFn: function() {
                    setMediaFetched(false);
                    setIsUrlSet(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: function(e) {
                    return handleSubmit(handleFormSubmit(e));
                },
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "mb-l",
                            (SidescreenAddMediaC_module_default()).inputWrapper
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_Input, {
                                callback: function(val) {
                                    return handleUrl(val);
                                },
                                register: register,
                                errors: errors,
                                description: formData.description
                            }),
                            isUrlSet && /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_CoveragePreview, {
                                title: formData.details.title,
                                body: formData.description,
                                source: formData.details.source,
                                isLoaded: isLoaded,
                                isEditable: isEditable,
                                isUrlEmpty: isUrlSet
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typo/* default */.Z, {
                        variant: "small",
                        className: [
                            (SidescreenAddMediaC_module_default()).toggle,
                            isEditable ? (SidescreenAddMediaC_module_default()).isActive : null, 
                        ].join(" "),
                        onClick: showManualEdit,
                        children: [
                            en/* profile.media_coverage.sidebar.manual */.N5.iT.rc.yC,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (SidescreenAddMediaC_module_default()).dropdown,
                            isEditable ? (SidescreenAddMediaC_module_default()).isActive : null, 
                        ].join(" "),
                        children: (mediaFetched || isEditable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_Details, {
                                    callback: function(val) {
                                        return handleDetails(val);
                                    },
                                    register: register,
                                    errors: errors,
                                    data: formData.details
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_Description, {
                                    callback: function(val) {
                                        return handleDescription(val);
                                    },
                                    register: register,
                                    errors: errors,
                                    description: formData.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: [
                                        "mb-m",
                                        (SidescreenAddMediaC_module_default()).alertPicker
                                    ].join(" "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                            variant: "small",
                                            className: "mb-xs",
                                            children: en/* profile.media_coverage.sidebar.coverage_alert */.N5.iT.rc.qI
                                        }),
                                        alertsSelected.map(function(param) {
                                            var id = param.id, value = param.value;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (SidescreenAddMediaC_module_default()).alertResolved,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                                        variant: "small",
                                                        children: value
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        className: (SidescreenAddMediaC_module_default()).alertRemove,
                                                        "aria-label": en/* profile.media_coverage.sidebar.coverage_alert_remove */.N5.iT.rc.gw,
                                                        onClick: function() {
                                                            return removeAlert(id);
                                                        },
                                                        children: "\xd7"
                                                    })
                                                ]
                                            }, "coverage-alert-".concat(id));
                                        }),
                                        alertOptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionSelect/* default */.Z, {
                                            options: alertOptions,
                                            value: {
                                                value: en/* profile.media_coverage.sidebar.coverage_alert_add */.N5.iT.rc.uP
                                            },
                                            setValue: addAlert
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            className: (SidescreenAddMediaC_module_default()).alertLink,
                                            placeholder: en/* profile.media_coverage.sidebar.coverage_alert_link */.N5.iT.rc.ij,
                                            value: alertLink,
                                            onChange: function(e) {
                                                setAlertLink(e.target.value);
                                                setAlertLinkError(null);
                                            },
                                            onBlur: function(e) {
                                                return handleAlertLink(e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleAlertLink(e.target.value);
                                                }
                                            }
                                        }),
                                        alertLinkError && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                            variant: "small",
                                            className: (SidescreenAddMediaC_module_default()).alertLinkError,
                                            children: alertLinkError
                                        })
                                    ]
                                })
                            ]
                        }, scrapeSeq)
                    }),
                    (mediaFetched || isEditable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                                title: en/* common.continue */.y0["continue"],
                                sticky: {
                                    position: "bottom"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_AddMediaCoverage = (AddMediaCoverage);

// EXTERNAL MODULE: ./api/index.js + 49 modules
var api = __webpack_require__(46979);
;// CONCATENATED MODULE: ./components/Sidescreen/EditMediaCoverage.js





















var EditMediaCoverage_text = en/* profile.media_coverage.edit */.N5.iT.eP;
var EditMediaCoverage = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(coverage/* coveragesSelector */.NQ), editing = ref.editing, respondedAlerts = ref.respondedAlerts;
    var ref1 = (0,index_esm/* useForm */.cI)(), register = ref1.register, handleSubmit = ref1.handleSubmit, errors = ref1.errors;
    var ref2 = (0,react.useState)({
        title: (editing === null || editing === void 0 ? void 0 : editing.title) || "",
        source: (editing === null || editing === void 0 ? void 0 : editing.publisher) || "",
        url: (editing === null || editing === void 0 ? void 0 : editing.url) || ""
    }), details = ref2[0], setDetails = ref2[1];
    // The list leaves the excerpt out of the page source, so it is read on its own.
    // Until it arrives it is not sent, and the API keeps what is stored.
    var ref3 = (0,react.useState)(undefined), description = ref3[0], setDescription = ref3[1];
    var ref4 = (0,react.useState)((editing === null || editing === void 0 ? void 0 : editing.alert) ? {
        id: editing.alert.id,
        value: editing.alert.title
    } : null), alert = ref4[0], setAlert = ref4[1];
    var ref5 = (0,react.useState)(false), applyToAll = ref5[0], setApplyToAll = ref5[1];
    var ref6 = (0,react.useState)(false), saving = ref6[0], setSaving = ref6[1];
    var ref7 = (0,react.useState)(null), error = ref7[0], setError = ref7[1];
    (0,react.useEffect)(function() {
        dispatch((0,coverage/* fetchRespondedAlerts */.mH)());
    }, []);
    (0,react.useEffect)(function() {
        if (!editing) return;
        var ref;
        (0,api/* getReq */.ZL)("/coverages/".concat(editing.id)).then(function(res) {
            var ref1;
            return setDescription((ref = (ref1 = res.data.data) === null || ref1 === void 0 ? void 0 : ref1.description) !== null && ref !== void 0 ? ref : "");
        }).catch(function() {
            return setDescription(undefined);
        });
    }, [
        editing === null || editing === void 0 ? void 0 : editing.id
    ]);
    if (!editing) return null;
    var alertOptions = (0,src_to_consumable_array/* default */.Z)(editing.alert ? [
        editing.alert
    ] : []).concat((0,src_to_consumable_array/* default */.Z)((respondedAlerts || []).filter(function(param) {
        var id = param.id;
        var ref;
        return id !== ((ref = editing.alert) === null || ref === void 0 ? void 0 : ref.id);
    }))).filter(function(param) {
        var id = param.id;
        return id !== (alert === null || alert === void 0 ? void 0 : alert.id);
    }).map(function(param) {
        var id = param.id, title = param.title;
        return {
            id: id,
            name: title
        };
    });
    var onSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, result, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setError(null);
                        return [
                            4,
                            dispatch((0,coverage/* updateCoverage */.Nd)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                id: editing.id,
                                title: details.title,
                                publisher: details.source,
                                url: details.url
                            }, description !== undefined ? {
                                description: description
                            } : {}), {
                                alertId: (ref = alert === null || alert === void 0 ? void 0 : alert.id) !== null && ref !== void 0 ? ref : null,
                                applyToAll: applyToAll
                            })))
                        ];
                    case 1:
                        result = _state.sent();
                        setSaving(false);
                        if (coverage/* updateCoverage.rejected.match */.Nd.rejected.match(result)) {
                            ;
                            setError(((ref1 = result.payload) === null || ref1 === void 0 ? void 0 : ref1.message) || EditMediaCoverage_text.error);
                            return [
                                2
                            ];
                        }
                        dispatch((0,ux/* handleHideSidescreen */.Qb)());
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_SidescreenHeader, {
                title: EditMediaCoverage_text.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_Details, {
                        callback: setDetails,
                        register: register,
                        errors: errors,
                        data: details
                    }),
                    description !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(addMediaCoverage_Description, {
                        callback: setDescription,
                        description: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "mb-m",
                            (SidescreenAddMediaC_module_default()).alertPicker
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                variant: "small",
                                className: "mb-xs",
                                children: en/* profile.media_coverage.sidebar.coverage_alert */.N5.iT.rc.qI
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionSelect/* default */.Z, {
                                options: alertOptions,
                                value: {
                                    value: (alert === null || alert === void 0 ? void 0 : alert.value) || EditMediaCoverage_text.no_alert
                                },
                                defaultValue: alert ? EditMediaCoverage_text.no_alert : undefined,
                                setValue: function(param) {
                                    var id = param.id, value = param.value;
                                    return setAlert(id ? {
                                        id: id,
                                        value: value
                                    } : null);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: [
                            "mb-m",
                            (SidescreenAddMediaC_module_default()).applyToAll
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: applyToAll,
                                onChange: function(e) {
                                    return setApplyToAll(e.target.checked);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                                variant: "small",
                                children: EditMediaCoverage_text.apply_to_all
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                        variant: "small",
                        className: "mb-m",
                        children: EditMediaCoverage_text.no_email
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                        variant: "small",
                        className: (SidescreenAddMediaC_module_default()).alertLinkError,
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                        title: EditMediaCoverage_text.save,
                        loading: saving,
                        sticky: {
                            position: "bottom"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_EditMediaCoverage = (EditMediaCoverage);

// EXTERNAL MODULE: ./styles/modules/popUps/FileUpload.module.scss
var FileUpload_module = __webpack_require__(74887);
var FileUpload_module_default = /*#__PURE__*/__webpack_require__.n(FileUpload_module);
// EXTERNAL MODULE: ./styles/modules/FilePreview.module.scss
var FilePreview_module = __webpack_require__(89260);
var FilePreview_module_default = /*#__PURE__*/__webpack_require__.n(FilePreview_module);
;// CONCATENATED MODULE: ./components/Svg/Download.js

function Download(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M410 279L256 432 102 279l28-29 106 106V0h40v356l106-106zm102 193H0v40h512zm0 0",
            fill: fill
        })
    });
}

// EXTERNAL MODULE: ./components/popUps/PopupConfirm.js
var PopupConfirm = __webpack_require__(67774);
;// CONCATENATED MODULE: ./components/FilePreview.js












var FilePreview = function(param) {
    var id = param.id, title = param.title, name = param.name, url = param.url;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthorized = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).isAuthorized;
    var shortName = (0,helpers_file/* getShortFileName */.Sv)(name);
    var ref = (0,react.useState)(false), confirming = ref[0], setConfirming = ref[1];
    var ref1 = (0,react.useState)(false), removing = ref1[0], setRemoving = ref1[1];
    var preview;
    var handleRemove = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setRemoving(true);
                        return [
                            4,
                            dispatch((0,store_company/* removeFile */.Yd)(id))
                        ];
                    case 1:
                        _state.sent();
                        setRemoving(false);
                        setConfirming(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    if (name.includes("jpg") || name.includes("jpeg") || name.includes("png") || name.includes("webp")) {
        preview = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: url,
            download: name,
            target: "_blank",
            className: [
                "border-gray",
                (FilePreview_module_default()).thumbnail
            ].join(" "),
            style: {
                backgroundImage: "url(".concat(url, ")")
            },
            rel: "noreferrer"
        });
    } else {
        preview = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: url,
            download: name,
            target: "_blank",
            className: [
                "border-gray",
                (FilePreview_module_default()).thumbnail
            ].join(" "),
            rel: "noreferrer",
            children: (0,helpers_file/* getFileExtPreview */.Cp)((0,helpers_file/* getFileExtension */.mD)(name))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FilePreview_module_default()).wrapper,
        children: [
            preview,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilePreview_module_default()).information,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: url,
                        download: name,
                        target: "_blank",
                        className: (FilePreview_module_default()).title,
                        rel: "noreferrer",
                        children: title || "File ".concat(id)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FilePreview_module_default()).name,
                        children: shortName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FilePreview_module_default()).icons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        download: name,
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download, {}),
                            "Download"
                        ]
                    }),
                    isAuthorized && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: function() {
                            return setConfirming(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {}),
                            "Remove"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* default */.Z, {
                active: confirming,
                title: "Remove ".concat(title || name, "?"),
                body: "It disappears from your Media Pack straight away.",
                confirmTitle: "Remove",
                loading: removing,
                onConfirm: handleRemove,
                onCancel: function() {
                    return setConfirming(false);
                }
            })
        ]
    });
};
/* harmony default export */ var components_FilePreview = (FilePreview);

;// CONCATENATED MODULE: ./components/Sidescreen/AddFiles.js








var AddFiles = function(param) {
    var files = param.files, title = param.title, showUploadPopup = param.showUploadPopup, hideUploadPopup = param.hideUploadPopup, activeUploadPopup = param.activeUploadPopup;
    var handleUploadSuccess = function() {
        hideUploadPopup();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_SidescreenHeader, {
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_AddContent/* default */.Z, {
                    className: "mr-xs",
                    data: {
                        direction: "row",
                        label: "Add new file",
                        onClick: showUploadPopup
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Uploader_Uploader, {
                isActive: activeUploadPopup,
                onCancel: hideUploadPopup,
                onSubmit: handleUploadSuccess,
                croppable: false,
                noSettings: false,
                allowedTypes: "files"
            }),
            files.length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (FileUpload_module_default()).emptyBlock,
                children: en/* profile.mediaPack.empty_block */.N5._K.c
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FileUpload_module_default()).fileGrid,
                children: files.map(function(file, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilePreview, {
                        id: file.id,
                        title: file.title,
                        name: file.name,
                        url: file.path
                    }, "preview-file-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var Sidescreen_AddFiles = (AddFiles);

// EXTERNAL MODULE: ./styles/modules/EditAddresses.module.scss
var EditAddresses_module = __webpack_require__(22581);
var EditAddresses_module_default = /*#__PURE__*/__webpack_require__.n(EditAddresses_module);
// EXTERNAL MODULE: ./components/AddressSearch.js + 1 modules
var AddressSearch = __webpack_require__(3010);
// EXTERNAL MODULE: ./components/Svg/Star.js
var Star = __webpack_require__(76997);
;// CONCATENATED MODULE: ./components/EditAddresses.js
















function EditAddresses(param) {
    var onUpdate = param.onUpdate, closeFn = param.closeFn, title = param.title;
    var dispatch = (0,es/* useDispatch */.I0)();
    var data = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX).data;
    var ref = (0,react.useState)(data.addresses || []), addresses = ref[0], setAddresses = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), updated = ref2[0], setUpdated = ref2[1];
    var handleRemove = function(keyToRemove) {
        var tmp = addresses.filter(function(item, key) {
            return key !== keyToRemove;
        });
        setAddresses((0,src_to_consumable_array/* default */.Z)(tmp));
        setUpdated(true);
    };
    var handleDefault = function(keyToDefault) {
        var tmp = addresses.map(function(item, key) {
            return (0,src_object_spread/* default */.Z)({}, item, {
                default: key === keyToDefault
            });
        });
        setAddresses((0,src_to_consumable_array/* default */.Z)(tmp));
        setUpdated(true);
    };
    var handleConfirm = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            dispatch((0,store_company/* updateAddresses */.Td)(addresses))
                        ];
                    case 1:
                        _state.sent();
                        setLoading(false);
                        setUpdated(false);
                        onUpdate();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var addressesList;
    if (addresses.length > 0) {
        addressesList = addresses.map(function(item, key) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "border-gray-bottom",
                    (EditAddresses_module_default()).listItem,
                    item.default ? (EditAddresses_module_default()).listItemDefault : null, 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typo/* default */.Z, {
                        children: item.fullAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (EditAddresses_module_default()).buttonRemove,
                        onClick: function() {
                            return handleRemove(key);
                        },
                        title: "Remove address",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                    }),
                    !item.default && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (EditAddresses_module_default()).buttonDefault,
                        onClick: function() {
                            return handleDefault(key);
                        },
                        title: "Make default address",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                            fill: "var(--color-blue)"
                        })
                    }),
                    item.default && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (EditAddresses_module_default()).iconDefault,
                        title: "Default address",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                            fill: "#fff"
                        })
                    })
                ]
            }, key);
        });
    } else {
        addressesList = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (EditAddresses_module_default()).listItem,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EditAddresses_module_default()).listItemTitle,
                children: en/* profile.header.address.sidebar.no_address */.N5.Fs.Lk.r.M7
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_SidescreenHeader, {
                title: title,
                closeFn: closeFn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "mb-l",
                    (EditAddresses_module_default()).list
                ].join(" "),
                children: addressesList
            }),
            addresses.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSearch/* default */.Z, {
                onUpdate: function(address) {
                    address.default = true;
                    var tmp = (0,src_to_consumable_array/* default */.Z)(addresses).concat([
                        address
                    ]);
                    setAddresses(tmp);
                    setUpdated(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-l",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                    title: en/* common.save */.y0.save,
                    disabled: !updated,
                    loading: loading,
                    onClick: handleConfirm
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Sidescreen.js













var Sidescreen = function(param) {
    var onUpdate = param.onUpdate;
    var dispatch = (0,es/* useDispatch */.I0)();
    var sidescreen = (0,es/* useSelector */.v9)(ux/* uxSelector */.sN).sidescreen;
    var data = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX).data;
    var ref = (0,react.useState)(false), activeUploadPopup = ref[0], setActiveUploadPopup = ref[1];
    var contentComponent;
    (0,react.useEffect)(function() {}, [
        sidescreen
    ]);
    var showUploadPopup = function() {
        setActiveUploadPopup(true);
    };
    var hideUploadPopup = function() {
        setActiveUploadPopup(false);
    };
    var files = data.files;
    switch(sidescreen.content){
        case "edit-description":
        case "edit-info":
            contentComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_EditCompanyInfo, {
                onUpdate: onUpdate,
                isJournalist: data.isJournalist,
                title: en/* profile.header.details.sidebar.title */.N5.Fs.Xv.r.TN
            });
            break;
        case "add-mediaCoverage":
            contentComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_AddMediaCoverage, {
                onUpdate: onUpdate,
                title: en/* profile.media_coverage.sidebar.title */.N5.iT.rc.TN
            });
            break;
        case "edit-mediaCoverage":
            contentComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_EditMediaCoverage, {});
            break;
        case "add-file":
            if (!files) return null;
            contentComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen_AddFiles, {
                files: files,
                title: en/* profile.mediaPack.title */.N5._K.T,
                showUploadPopup: showUploadPopup,
                hideUploadPopup: hideUploadPopup,
                activeUploadPopup: activeUploadPopup
            });
            break;
        case "add-address":
        case "edit-addresses":
            contentComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(EditAddresses, {
                onUpdate: onUpdate,
                title: data.addresses.length > 0 ? en/* profile.header.address.sidebar.title */.N5.Fs.Lk.r.TN : en/* profile.header.address.sidebar.title_no_address */.N5.Fs.Lk.r.ZM
            });
            break;
        default:
            contentComponent = null;
            break;
    }
    (0,react.useEffect)(function() {
        var handleKeyUp = function(e) {
            var ref;
            var key = (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (key === "escape") {
                dispatch((0,ux/* handleHideSidescreen */.Qb)());
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        return function() {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: [
            (Sidescreen_module_default()).sidescreen,
            sidescreen.active ? (Sidescreen_module_default()).sidescreenActive : null,
            activeUploadPopup ? (Sidescreen_module_default()).popupActive : null, 
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Sidescreen_module_default()).body,
            children: contentComponent
        })
    });
};
/* harmony default export */ var components_Sidescreen = (Sidescreen);


/***/ }),

/***/ 97919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29455);
/* harmony import */ var styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64798);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23775);
/* harmony import */ var _helpers_strings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66998);






var LimitedTextArea = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_helpers_strings__WEBPACK_IMPORTED_MODULE_4__/* .br2nl */ .dl)(props.value) || ""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.limit - val.length), counter = ref1[0], setCounter = ref1[1];
    var handleChange = function(e) {
        var ref;
        var newVal = e.target.value;
        if (newVal.length > props.limit && newVal.length > val.length) {
            return;
        }
        setVal(newVal);
        setCounter(props.limit - newVal.length);
        var newValFormatted = (0,_helpers_strings__WEBPACK_IMPORTED_MODULE_4__/* .nl2br */ .hU)(newVal);
        (ref = props.callback) === null || ref === void 0 ? void 0 : ref.call(props, newValFormatted);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    "mb-xxs",
                    (styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().descriptionHeader)
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "body",
                        Tag: "label",
                        htmlFor: "description",
                        children: props.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().counter),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: counter < 10 ? (styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().limited) : "",
                                children: counter
                            }),
                            " ",
                            lang_en_json__WEBPACK_IMPORTED_MODULE_2__/* .profile.header.details.sidebar.out_of */ .N5.Fs.Xv.r.wn,
                            " ",
                            props.limit,
                            " ",
                            lang_en_json__WEBPACK_IMPORTED_MODULE_2__/* .profile.header.details.sidebar.characters_left */ .N5.Fs.Xv.r.vH
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                name: "description",
                id: "description",
                className: (styles_modules_SidescreenEditCompanyInfo_module_scss__WEBPACK_IMPORTED_MODULE_5___default().descriptionTextarea),
                onChange: handleChange,
                value: val,
                maxLength: props.limit,
                placeholder: props.placeholder ? props.placeholder : props.isJournalist ? lang_en_json__WEBPACK_IMPORTED_MODULE_2__/* .profile.header.details.sidebar.description_placeholder_journalist */ .N5.Fs.Xv.r.Op : lang_en_json__WEBPACK_IMPORTED_MODULE_2__/* .profile.header.details.sidebar.description_placeholder */ .N5.Fs.Xv.r.GM
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LimitedTextArea);


/***/ }),

/***/ 6607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Remove; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Remove(props) {
    var fill = props.fill ? props.fill : "#f44336";
    var fillCross = props.fillCross ? props.fillCross : "#fafafa";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fillCross,
                d: "M350.3 320.1a21.3 21.3 0 11-30.2 30.2L256 286.2l-64.1 64a21.3 21.3 0 01-30.2 0 21.3 21.3 0 010-30l64.1-64.2-64-64.1a21.3 21.3 0 1130-30.2l64.2 64.1 64.1-64a21.3 21.3 0 1130.2 30L286.2 256zm0 0"
            })
        ]
    });
}


/***/ }),

/***/ 25192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"AddressSearch_input__VIjjH","wrapper":"AddressSearch_wrapper__KTKaJ","inputWrapper":"AddressSearch_inputWrapper__WY5pB","hasLabelAbove":"AddressSearch_hasLabelAbove__eGjbA","inputActive":"AddressSearch_inputActive__nfF7c","results":"AddressSearch_results__1NJ8i","resultsItem":"AddressSearch_resultsItem__EAfcr"};

/***/ }),

/***/ 53074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"CrosshatchLine_line__SPcjL"};

/***/ }),

/***/ 57223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__H0elj"};

/***/ }),

/***/ 22581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"EditAddresses_listItem__ZFwC4","buttonRemove":"EditAddresses_buttonRemove__u_q_Z","buttonDefault":"EditAddresses_buttonDefault__dj1_S","listItemDefault":"EditAddresses_listItemDefault__K5g0B","iconDefault":"EditAddresses_iconDefault__itRdB"};

/***/ }),

/***/ 89260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilePreview_wrapper__9x12X","thumbnail":"FilePreview_thumbnail__OUdaq","information":"FilePreview_information__EViQS","title":"FilePreview_title__tkbAR","name":"FilePreview_name__jOEvP","icons":"FilePreview_icons__HqCI3"};

/***/ }),

/***/ 17010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidescreen":"Sidescreen_sidescreen__IEXSU","sidescreenActive":"Sidescreen_sidescreenActive__vS_5F","popupActive":"Sidescreen_popupActive__egDUs","header":"Sidescreen_header__Ve1tc","line":"Sidescreen_line__F8Cup","title":"Sidescreen_title__QQGK0","close":"Sidescreen_close__DZiNh","body":"Sidescreen_body__wgTUT","headerPublic":"Sidescreen_headerPublic__2a_43"};

/***/ }),

/***/ 66919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"SidescreenAddMediaC_inputWrapper__9M9jv","dropdown":"SidescreenAddMediaC_dropdown__80KFO","isActive":"SidescreenAddMediaC_isActive__8B3Ys","alertPicker":"SidescreenAddMediaC_alertPicker__RZgq_","alertLink":"SidescreenAddMediaC_alertLink___ad8y","alertLinkError":"SidescreenAddMediaC_alertLinkError__MUuNZ","alertResolved":"SidescreenAddMediaC_alertResolved__SUkQ0","alertRemove":"SidescreenAddMediaC_alertRemove__5hh_1","toggle":"SidescreenAddMediaC_toggle__BZdIa","applyToAll":"SidescreenAddMediaC_applyToAll__zH3eB"};

/***/ }),

/***/ 29455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bio":"SidescreenEditCompanyInfo_bio__vOOqp","logoWrapper":"SidescreenEditCompanyInfo_logoWrapper__0OvD1","logoEdit":"SidescreenEditCompanyInfo_logoEdit__r8MaE","bioLogo":"SidescreenEditCompanyInfo_bioLogo__XWco_","bioLogoArea":"SidescreenEditCompanyInfo_bioLogoArea__5IAZB","bioBody":"SidescreenEditCompanyInfo_bioBody__OENa8","social":"SidescreenEditCompanyInfo_social__G54LZ","socialItem":"SidescreenEditCompanyInfo_socialItem__nWOl4","remove":"SidescreenEditCompanyInfo_remove__kG0bW","liveSocial":"SidescreenEditCompanyInfo_liveSocial__UlDBS","enter":"SidescreenEditCompanyInfo_enter__umc91","pulse":"SidescreenEditCompanyInfo_pulse__2wGPx","enterActive":"SidescreenEditCompanyInfo_enterActive__MvDLI","descriptionHeader":"SidescreenEditCompanyInfo_descriptionHeader__VnMwm","descriptionTextarea":"SidescreenEditCompanyInfo_descriptionTextarea__RJ2Xj","counter":"SidescreenEditCompanyInfo_counter__ARSJm","companyLogo":"SidescreenEditCompanyInfo_companyLogo__ELYcd","inputWrapper":"SidescreenEditCompanyInfo_inputWrapper__r3FJd","tick":"SidescreenEditCompanyInfo_tick__9JE83","limited":"SidescreenEditCompanyInfo_limited__VbWrv"};

/***/ }),

/***/ 11285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"CoveragePreview_item__NNPu1","title":"CoveragePreview_title__xjwgG","body":"CoveragePreview_body__QkTGU","loaderWrapper":"CoveragePreview_loaderWrapper__cr_rT","loader":"CoveragePreview_loader__Plmxr","spin":"CoveragePreview_spin__Kup7q"};

/***/ }),

/***/ 48181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"Input_description___xYr_","descriptionLabel":"Input_descriptionLabel__JaWUH","descriptionTextarea":"Input_descriptionTextarea__9NkJx"};

/***/ }),

/***/ 74887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileUpload_wrapper__LYlqa","isActive":"FileUpload_isActive__hJSw4","popUp":"FileUpload_popUp__LLetu","dragAndDrop":"FileUpload_dragAndDrop__4YDfS","title":"FileUpload_title__mBvSl","plus":"FileUpload_plus__1sZSK","line":"FileUpload_line__suth8","fileGrid":"FileUpload_fileGrid__ATu_H","emptyBlock":"FileUpload_emptyBlock__Ns08L"};

/***/ }),

/***/ 23093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Uploader_overlay__s4A6q","wrapper":"Uploader_wrapper__uHq2w","isActive":"Uploader_isActive__Sq_U6","dropArea":"Uploader_dropArea__gqhGB","dropActive":"Uploader_dropActive__s_RlZ","dropAreaBody":"Uploader_dropAreaBody__IUguE","dropInput":"Uploader_dropInput__H3WAq","header":"Uploader_header___ztaX","close":"Uploader_close__iS67E","title":"Uploader_title__PviIh","error":"Uploader_error__UDLyp","dropAreaTitle":"Uploader_dropAreaTitle__pjvH4","dropAreaPlus":"Uploader_dropAreaPlus__ORSww","dropAreaSubtitle":"Uploader_dropAreaSubtitle__Jn310","crosshatch":"Uploader_crosshatch__AS_Dt","settingsRow":"Uploader_settingsRow__94wrD","settingsPreview":"Uploader_settingsPreview__ObCgj","settingsBody":"Uploader_settingsBody__Htlwy","progressBar":"Uploader_progressBar__4oRqx","progressBarFill":"Uploader_progressBarFill__nMlI0","successWrapper":"Uploader_successWrapper__NFEQs","successTitle":"Uploader_successTitle__Kwlf2","successIllustration":"Uploader_successIllustration__lDv0l","cropContainer":"Uploader_cropContainer__pczP4","cropControls":"Uploader_cropControls__1GgwP","cropRange":"Uploader_cropRange__dai24"};

/***/ })

}]);